import { TSvgComponentProps } from '../../types';

/**
 * -----------------------------------------------------------------------------
 * An illustration showing a products distribution internationally.
 */
export function IllustrationProductsInternationally(props: TSvgComponentProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 400 340"
      xmlSpace="preserve"
      width="25em"
      height="21.25rem"
      id="man-checking insde empty box"
      version="1.1"
      x={0}
      y={0}
      {...props}
    >
      <style>
        {
          '.st0{fill:#e0d7d7}.st1{opacity:.3;fill:#aa4335;enable-background:new}.st5{fill:#fff}.st6{fill:#aa4335}'
        }
      </style>
      <path
        d="M53.5 197.5c1.1-.2 2.2-.5 3.5-.8-1.2.8-2.2 1.5-3.2 2.1.1.1.3.2.4.2.7-.2 1.5-.3 2.1-.5-.7 1-1.3 1.7-1.9 2.6.2.1.4.2.5.2 3-1.7 5.9-3.5 9.2-5.4-.9 0-1.3-.1-2-.1 2.2-1.9.8-4 3-5.9 2-1.8 3-3.9 4.7-6.2-2 .8-3.5 1.3-4.7 2-3.6 2.1-7.1 4.3-10.5 6.4-1.3.8-2.4 1.7-3.6 2.6-1.6 1.2-3.2 2.3-4.9 3.5 5.3-.1 7.3-2.9 10.9-4.2-1 1-2.2 1.8-3.4 2.6-.2.2 0 .5-.1.9-2 .5-4 1.2-6.1 1.7-2.8.7-3.5 1.3-2.2 3 1-.4 2-.7 2.7-1 .6.1 1.1.3 1.5.2 2.6-.1 4.3-1.9 4.1-3.9zm245.3-46.6c-1.3-.5-2.3-.9-3.4-1.2-1-.3-2.1-.7-3.2-.8-1-.1-2.3.2-3.3 0-3.2-.6-5.4-1.9-6.9-3.9 3.2.1 6.2.3 8.9.4.1-.9.4-2 .5-3.2 0-.2-.2-.5-.5-.6-1.5-.8-3-1.7-2.8-3.1 0 0-.2-.1-.3-.1-.7.4-1.2 1.1-2 1.2-3.9.7-6.7-.7-6.1-3 .3-1.1 1.2-1.1 2.3-.8.3-.5.5-1.1.9-1.6.7-.9 1.9-1.8 2-2.7.1-1.4-.4-2.9-1-4.2-1-2.1-1.7-1.8-3.1-3.1-1.7-1.5-4.3-1.5-7-2 .2-.9.4-1.9.6-3.2-1.2.7-2.1 1.2-3.1 1.9-.3 0-1.1.1-1.7 0-.4 0-1-.3-1-.5.1-.7.4-1.5.7-2.2.1-.3.4-.5.7-.9.5.6.9 1.1 1.3 1.5.7-1 .9-1.9 3-2.1.4.4.8.7 1.2 1.1.7-.2 1.3-.4 1.8-.5 1.2.7 2.2 1.5 3.4 2.2 3.4-1.9 1-3.6-4.4-3.9-.1-.7 0-1.5-.3-2.2-.5-1-.9-1.7.9-2.5.7-.3 1.1-1 1.1-1.5-.4-2.9-.8-5.9-4.2-8.2-.8-.6-1.7-1.2-3.2-.9-.6.1-.9.7-1.4 1.1-.3.2-.7.5-1.1.5-.7 0-1.5-.1-2.2-.1.3-1.5.8-3.2.9-4.8.1-1.1 1.1-1.7 2.3-2.5 1.1-.7 2.1-1.5 3.2-2.2.4-.2.9-.7 1.2-.6 2.2.1 2.5-1.1 3.7-1.7-2-.8-.9-2-.6-2.8.3-.9 1.7-1.4 3.7-.8.3-1.1.6-2.1.8-3 1.1.5 1.4 1.1.8 2.1-.6 1.1-.2 2.4-.9 3.5-.8 1.2-.4 2.3.7 3 1.6 1 3.8 1.5 6.1 2.4-.1-1.8-.2-3.4-.4-5.2-1-.1-1-.7 0-1.5-1.1-.3-2-.5-3.2-.8-.5-1.5-.5-1.5 2.1-3.9.5-.5 1.7-.7 2.5-1 .9-2.1 1.5-4.3 5.4-6-1.5-.2-2.5-.4-3.3-.5.2-.8.5-1.7.7-2.6.3 0 1 0 1.5-.1 1-.2 2-.5 2.9-.8.8-.3 2.1-.6 2.3-1 .5-.7.2-1.5.3-2.4-1.7.4-4 .3-4.1 1.6-6.4.7-11.5 2.6-15.6 5.2.2.5.6 1 .4 1.1-.5.2-1.7.5-1.7.4-1.1-.9-1.3-.1-1.8.3-.2.3-.5.7-.9.8-2.5.9-3.7 3.1-7.4 2.9-.2 0-.4.1-.5.2-3.1 1.4-5.4 3.2-9.5 4-3 .6-5.3 2.5-8 3.9.6.4.9.5 1.4.8-2 1.1-3.9 2.3-5.8 3.4-.2.4-.3 1-.9 1.3-1.7.9-2.5-.2-3.9-.7-1.9 1-4.7 1.4-5.2 3.4-.2.8-1.7 1.5-3.7 1.8-2 .3-3.5 1.7-5.2 2.5-.6.3-1.3.6-1.7.9-.8.7-1.4 1.5-2.1 2.2-.2-.1-.4-.1-.7-.2 1.2-1.5 2.5-2.9 3.7-4.4-2.2-.5-5.2.4-6.5 1.8-.2.2-.7.4-1.1.5-2 .4-4.1.8-4.5 2.3-.5 1.8-2.3 3.1-4.5 4.3-2.6 1.5-4.7 3.1-5.8 5.1.5 0 .8 0 1.4.1-1.6 1.1-3.1 2.1-5.2 3.6 1.6-.1 2.7-.1 4.3-.2-2.2.8-4 1.4-5.9 2.1l.2.2c.4 0 .8 0 1.1-.1-.4.5-.8.9-1.2 1.4-.4-.2-.9-.5-1.3-.7-.2.6-.4 1.2-.5 1.7.5.1 1.3 0 1.5.2 1.3 1.7 2.4.5 3.6-.2 1-.6 1.3-.6 1.8 0l-2.7.9c1.7 1.4 1.3 2.7-.8 3.5.2-.5.5-1.1.5-1.6 0-.3-.4-.9-.8-1-2.2-.4-3.5-1.3-4.8-2.5-.9.5-2.1.8-2.5 1.4-.5.7-.4 1.6-.7 2.8 1.4.2 2.9.4 4.6.6-3.6 1.2-7.2 2.4-10.7 3.6 0 .1.1.2.1.2 1-.1 2-.2 3.4-.4-.4.5-.5.8-.9 1-2 1.2-4.1 2.4-6 3.6-1.4.9-2.3 2-2.2 3.2 0 .2-1.1.6-1.7.9h-.5c.1-.4.2-.7.5-1.3-1.2.5-2 .7-3.1 1.2 1.2.5 2 .9 2.8 1.2-2.3 1.2-2.9 2.2-1.9 3.3-.9.4-1.9.8-2.8 1.2.1.1.2.1.2.2.5 0 1.1-.1 1.7-.2 0 .2.1.3.1.5-1.2.2-2.4.5-3.6.5-1.1 0-2.1-.2-3.2-.4.4-.1 1-.3 1.4-.5 1.5-.7 3.1-1.5 4.5-2.3.4-.2.3-.8.4-1.3-.7 0-1.5-.1-2 .1-2.2.6-4.2 1.3-6.3 2-1.3.5-2.7 1.5-3.7 1.4-2.9-.2-3.8.7-4.8 1.9-.5 0-1 .2-1.2.4-.5.4-.9.8-1.2 1.2-1 1.3-3.5 2.2-3.2 3.8 0 .1-.3.2-.4.3-.5.4-.9.8-1.3 1.2.2 0 .3.1.5.2.3-.1.7-.2.7-.3.2 1.1.5 2.2.5 3.3-.1 1-.4 2-1 2.9-1.8 2.4-1.4 3.5 2.3 4.4 1.7.4 3.1 0 3.6-1 .2-.5.5-1 .9-1.7 2.3.4 4.5.7 6.7 1.1.2-1.2 1.8-2.4-.3-3.3-.3-.1-.1-.7 0-1 .2-.8 0-1.4-1.8-1.2-.7 0-1.7-.3-2-.7-.3-.5 0-1.2 0-1.8 0-.7.2-1.4 0-2-.2-1 1-1.9 2.9-2-.2.9-.4 1.8-.7 2.7-.4 1.2 1.2 1.7 2.4 2 .7.2 2.3-.5 3.2-.9.8-.4 1.2-1.1 1.8-1.6.5-.4 1.2-.7 1.8-1l.6.3c-1 .7-2.1 1.5-3.1 2.2-.8.6-1.6 1.2.5 1.2.5 0 .9.5 1.5.8-3.4.6-3.5.9-.7 2.8-.4.5-.6 1-1.1 1.4-1.7 1.2-3.6 2.5-5.5 3.6-.5.3-1.4.5-2.1.5-.4 0-.8-.3-1.1-.5l-1.5-1.5c-3.4 2.5 1.9 2.2 2.2 3-.8 1.3-1.6 2.2-1.8 3.2-.3 1.3-.2 2.7-.5 4 0 .3-.7.7-1.2 1 1.8 1-2 1.2-1.4 2.3 3.4-.7 6.5-.8 7.6 1.5-1.6.9-3.2 1.8-4.6 2.7-.5.3-1 1.2-.7 1.3 2 1.3 4.2 2.5 6.3 3.7.1-.1.2-.3.3-.4 1.2-.3 2.4-.6 3.7-.9.4-.4 1-.9 1.6-1.4 1.3-1 1.2-2.2.1-2.8-1.5-.9-1.2-1.7-1-2.8.1-.4 0-1-.5-1.3-.7-.5-.5-1 .4-1.2 1.8-.4 2.1-1.3 2.3-2.1.2-1 1.1-.9 2.2-.9 1.8 0 3.6 0 5.4-.1 2-.1 4.1-.5 5.4.8.2-.1.3-.2.5-.3-.6-.5-1.2-1-1.9-1.6.4-.1.9-.3 1.4-.5-.8-.2-1.5-.2-2.2-.1-2.4.5-4.7.5-7.1.2-.6-.1-1.1-.4-1.5-.7-.1 0 .2-.5.4-.5.8-.1 1.6-.2 2.5-.2 1.3-.1 2.6-.1 3.9-.2 1.2 0 2.4-.2 3.5 0 2.3.5 4.5 1.1 6.8 1.6.3.1.9-.1 1.4-.2-.4-.7-.4-1.5-1.1-1.8-.7-.3-2-.2-2.6-.3.2-.5.2-1 .5-1.3.4-.4 1.1-.7 1.8-1.1.7 1.2 3.2 2 5.1 1.8 1.4-.2 3.1-.2 2.7-1.7 3.2.6 2.7-1.5 4.8-2.2 1.2 1.1 2.3 2.2 3.4 3.2.7.6.6 1.2-.3 1.8-.5.4-.5.9-1 1.6 2.7-1 3.7-.7 4.4.6.5-.5 1-1 1.6-1.5.2 0 .5 0 .7.1 3.5.7 7.6.8 10.5 2.3.3.2.7.2 1.1.2 3.5 0 6.5.6 9.2 1.9 2.9 1.4 3.3 1.3 4.4-.8 1.2-2.4 1.6-4.8 2.9-7.2.8-1.5-.5-2.5-.8-3.8-.4-1.5-1.4-2-3.2-1.5-2 .5-3.2.2-4.5-.6-.4 1.3 1.2 2.7-2 3.5-.6-.3-1.3-.6-2-1-.1.1-.2.1-.3.2l.3.6c-2-.4-3.9-.6-5.7-1.1-.5-.1-.7-.7-1-1 .6-.2 1.2-.4 1.8-.5.5 0 1 .1 1.4.2 3.2.6 5.3.1 7.1-1.7 2.4 1 3.9-.4 5.4-1 1.7-.7 2.9-1.8 4.1-2.5 2.2 0 4.1.1 6 .1-.1.9 1.5.8 2.3.6.6-.2.9-.9 1.3-1.4 4.9 2.9 11.9 4.4 19 6.3-.2-2.5-2-4.1-4.5-5.4-.6-.3-1.3-.7-1.4-1.1-.2-2.3.3-4.7-.9-6.9-.1-.2.3-.5.5-.7.7-.7 1.5-1.4 2.3-2.1 2.2 1.5 7.5.2 9 2.9.2 0 .4-.1.6-.1.3-.6.7-1.3 1-2 3.5 1.1 7 2.2 9.4 4.2.4.3 1.2.5 2 .7 1.6.4 3.3.7 4.8 1.2 1.4 1 3.5 1.1 6.2.5zM28.5 241.1c2.2-.9 4.1-1.7 6.1-2.5 2.2-.8 4.5-1.5 6.8-2.2 1-.3 1.6-.3 1.9.4.3.7 3.1 1.1 3.5.5.6-.9 1.3-.7 2.3-.5 2.3.4 4.6.7 7.2.1 1.5-.4 3.2-.5 4.8-.7 0 .1 0 .2.1.4-.4.3-.8.7-1 .9 1.4.7 2.9 1.2 3.8 2 2.8 2.4 7 3.3 11.7 3.8.7.1 1.6.2 2.2.1 1.7-.5 3.2-.4 4.8-.1 1.7.4 3.5.5 5.3.7.3 0 .9.1.9.2.1 1.1 1.4.5 2.4.5.5 0 1.2-.1 1.7 0 1.6.2 3.2.5 4.9.7.1-.2.2-.3.3-.5L85 242.8l.3-.6h2.3c1.2.2 2.4.5 3.6.6 3.1.2 6.3.4 9.4.6 1 .1 2.1.3 2.6.7 1.1.9 2.6.9 4.2.7 2.7-.4 5.4-1 8-1.5.5-.1 1-.4 1.2-.7.4-.9 1.4-1 2.7-1 1.5-.1 3.2-.2 4.6-.6 1.9-.6 3.6-.5 5.4-.3.6.1 1.2.5 1.8.5 2.2-.2 4.5-.5 6.6-.8-.3-.6-.6-1-1-1.7 2 .2 3.4.6 4.7.5 1.5-.2 2.5 0 3 .7.6.8.9 1.7 1 2.5.1 1.4.9 2.2 2.9 2.7.6.7 1.3 1.4 2.4 1.7 2.3.5 4.9.7 7.3 1 3.1.5 6 1.2 9.5.2 2-.6 4-.2 5.3.8 2.3 1.8 4.6 3.7 7.1 5.4 1.7 1.2 3.7 2.3 4.5 4 .5 1.1 2 1.9 3.2 2.8.1 0 .2.1.4.1 2.4-.5 2.4.8 3.4 1.4v.2l-1.6-.4c.6.9 1.1 1.6 1.6 2.3.3-.1.7-.2 1.2-.3-.3 1.3 2 2.7 5.1 3.1 2.7.4 7.4-1.5 8.8-3.5-4.2.8-5.7.4-6.3-1.9-.1-.3.1-.7.2-1.1.1-.7-.2-1-1.5-.6-.4.1-.8.1-1.6.2.6-1.7.7-3.2-2.7-4 2.8-.7 2.8-1.5 1.6-2.2.9-1.1 2-2 2.4-3 .5-1.5-2-1.2-4-1.5 5.4-1.1 4.2-3 2.9-5 .6.1.9.1 1.5.2-.8-1.3-1.2-2.6-2.4-3.6-1.1-.9-1.4-1.6-.7-2.6.7-.9 1.5-1.7 2.2-2.7.2-.3.5-.8.3-1.1-1.2-1.8-2.1-3.8-5-5-.5-.2-.7-.7-.8-1-.3-1.2-.5-2.5-.9-3.8-.3-.9-2.5-1.6-3.9-1.4-1.2.2-2.5.3-3.7.6-1 .2-2.1.6-3 1-1 .4-2 1.3-2.7 1.2-2-.2-3.3.6-4.9 1-1 .2-2.4.2-3.3 0-4.2-1.2-5.7-1.1-9.6.7-.7.3-1.7.5-2.6.5-2.2.2-4.3.2-6.5.3-.4 0-1 .3-1.2.5-1.3 1.7-4 2-6.8 2.6.5.7.9 1.3 1.4 2-.1 0-.2.1-.3.2-.8-.5-1.6-1.1-2.4-1.7-1 1.7-2.5 3.4-.5 5.2-1.1.1-1.9.3-2.5.2-1.9-.1-3.1.2-3.6 1.4-.1.2-1 .5-1.5.5-3 .3-4.2-1-5.6-2.1-1.2-1-2.8-1-4.3.1-.5.4-1.1.8-1.8 1.3-1.5-1.5-2.9-2.7-4.5-4.3-.8.7-1.5 1.3-2.2 1.9.5.4.8.6 1.1.9 1.1 1-.1 1.7-1.1 2.4-.7.4-1.9.6-2.8.6-1 0-2.2-.2-2.9-.6-1.8-.9-3.3-2-5-2.9-2.7-1.5-1.9-3.7 1.7-4.7 1.3-.3 1.8-.8-.3-1.4 1.9-.7 3.7-1.1 4.9-1.9 1.4-.9 2.1-.5 3.2-.1 1.4.5 3 .7 4.5 1.1.2-.1.3-.2.5-.4-.5-.4-1-.9-1.7-1.2-1.2-.5-2.7-.8-4-1.3-.7-.3-1.6-.9-1.7-1.4-.2-1-.1-2.1.3-3.1s-.2-1.5-1.4-1.9c-1-.3-1.8-.7-2.7-1 0 0 .1-.1.2-.1.5.2 1.1.3 1.9.5-.4-1.7-3.3-3.2.4-4.7-2.5-1-2.1-3.1.5-4.8.2.4.5.9.7 1.3.1 0 .3 0 .4-.1.8-1.3 1.6-2.7 2.4-4.1-.7-.1-1.2-.2-1.2-.2-.5.7-.8 1.6-1.4 1.7-1.4.2-2.8.1-4.4.1.2-.5.4-.8.6-1.2-2.9.2-2.5 1.8-4.1 2.5.4-1 .6-2.3 1.7-2.9 2.6-1.3 4.4-2.8 5.1-4.7.1-.4.3-.9 0-1.1-.4-.2-1.3-.3-2-.2-1.6.2-3.2.1-4.7.8-.4.2-1.4.1-2.1 0-2.1-.4-4.2-.8-6-1.1-.3 1.1 0 2.2-.8 2.7-1.2.7-3 .4-3.8-.3-3.6.4-6.4 1.3-8.4 2.9 1.3.7 2.5 1.4 4 2.3 3.7 0 3.8.2 2.7 2.9 3.7 1.2 3.7 1.2 2.3 2.7-1.8-.4-3.6-.8-5.2-1.2-3.4 1-6.8 2-10.6 3.1-.3 0-1.4-.3-2-.1-2.1.8-2.6-.2-2.7-.8-.2-1.4-.5-2.9.5-4.1 1-1.3.5-2.2.3-3.5.8-.2 1.7-.4 2.7-.5-.2 0-.4-.1-.6-.1.2-.6.5-1.2.7-1.6-.8-.5-1.4-.8-2.3-1.3-.9.3-2 .8-3 1.2.3.8.6 1.5.8 2.1 0 .2-.2.5-.5.6-.3.1-1 .1-1.2 0-1.9-1.2-1.9-.1-2.1.4-2.2.1-4.4.1-6.5.2 0 0-.2 0-.2.1l-.9 1.5c.7.1 1.5.2 2.2.2.8 0 1.6-.1 2.4-.2-.2.7-.5 1.3-.6 1.8-1.3-.4-2.2-.2-2.8.7-.3.5-.8 1-1.4 1.3-2.2 1.1-4.5 2.2-6.6 3.3.6.2 1.3.3 2 .5-3.5 0-4.3 2.1-6.7 2.8-.7-.1-1.4-.2-1.8 0-1.8.7-3.6 1.5-5.3 2.2-.7.4-1.3.9-2.1 1.5h-1c.2 1.4-1.6.9-2.3 1-.8.5-1.4.9-1.9 1.2-1.3 1-3.1 2-3.7 3.2-.4.7-.9 1-1.8 1.3-1 .3-2 .7-2.9 1-3.9 1.7-7.7 3.4-11.6 5.2-1.2.5-2.7 1.1-3.5 1.8-1.9 1.9-3.4 4-5 5.9-.1.1 0 .2 0 .5 2.2-.6 4.2-1.1 6.3-1.7.2.1.3.2.5.3-2 1-4.7 1.6-4.7 3.3 3 .2 4.3-1.3 6-2.5.5.2.9.3 1.3.5-1.2 1.2-3.4 2.2-2 3.5.7.7 3.5.2 4.9-.8.5.2 1 .4 1.4.5 1.2-.7 2.2-1.3 3.3-2h.7c0 .6.2 1.2 0 1.8-.2.7-.7 1.3-1.1 1.9-.4.6-.7 1.2-1.1 2 1.3-1 2.5-1.9 3.7-2.8 0 0-.5-.2-.5-.4.4-1.2 1-2.3 1.4-3.5.1-.3.3-.8 0-1-1.3-.9-.2-1.9 0-2.8.2.5.5 1 .9 1.7 1.2-1.1 2-1.9 2.9-2.7 0-.1-.3-.2-.5-.3zM177 187.8c-.2 1.1-.4 1.9-.5 2.7 0 .5 0 1 .4 1.3 1.6 1.1 2.2 2.3.5 3.7-.1.1 0 .2.1.3.5 1.2.9 2.5 1.5 3.7.3.7.6 1.3 2.1 1.6 1.5.3 2.6 1.2 3.5 2 1.4 1.2 2.7 2.2 5.7 2 1.2-.1 2.5.1 3.8.1h5.6c2.4 0 3.7-.8 4.4-2.1.1-.2.3-.3.5-.4 2.5-1 3.6-2.5 4.8-3.9.7-.7 1.7-1.6 3.7-1 .4.1 1.5-.2 1.9-.5 2-1.2 3.3-1.2 4.6.1 1.2 1.4 2.8 2.2 5.8 2.1 1 0 2 .2 3 .5 1.7.5 3.2 1.2 5 1.6 1.2.3 1.7.7 2 1.5.8 1.7 2 3.2 5.6 3.7 2 .2 3.8.9 5.6 1.4 2 .6 3.7 1.4 6.3 1.5 1.6 0 3.1.8 4.6 1.2 1.3.4 2.5.5 3.4-.5.5-.6 1.2-1.2 2-1.7 3.2-1.6 3-3.5 2.7-5.5-.2-1-.6-2-1.5-2.8-.7-.5-1-.9-.4-1.5.9-1 .3-1.9-1.1-2-3.1-.5-2.8-1.8-2.6-3.2 0-.4.5-.8.6-1.2.1-.6.5-1.4 0-1.7-1.5-.9-3.4-1.7-5.2-2.4-1.6-.6-3.3-1.2-4.9-1.8-.2 0-.2-.2-.2-.3-.4-2.2-1.2-4.4-.9-6.6.4-2.7-1.1-5-2.8-7.3-.2-.2-.7-.4-1-.6-1.3 1.2-2.6 2.3-3.6 3.5-.8.9-1.9.6-2.9.6-1.5-.1-3-.2-4.4-.4-2.4-.2-5.3 0-7.2-.7-2.4-.9-5.2-1-7.7-1.6-2.1-.5-4.3-.9-6.3-1.4-1.3-.3-1.9.1-2.6.7-.7.6-1.5 1.2-2.5 1.5-1.5.6-3.1 1-4.7 1.5-1.8.5-2.1 1.2-1.2 2.2.2.2.2.8 0 .9-1.3.4-2.7.7-4.2 1.1-1 .2-2.1.3-3 .6-1.1.3-2.2.8-3.1 1.1-.7-.9-1.2-1.5-1.9-2.3-1.2.7-2.3 1.2-3.2 1.9-1.8 1.3-4 2.6-5.2 4-1.6 1.2-2.6 2.4-4.9 2.8zM113.5 175c1.4-.4 2.4-.7 3.5-1-1.1-1-2.3-.8-3.6-.5-1.3.3-2.3.2-2.5-.8 2-.5 3.6-1.3 2.9-2.5-.5-.7-2.2-1.1-3.5-1.7.2-.2.7-.6 1.2-1-.1-.1-.2-.2-.2-.3-1.2.3-2.5.6-3.9.9-.5-2.2 1.6-4.4 3.5-6.9-2.9.6-4.3 1.6-5.4 2.8-1.1 1.1-2.4 2.1-3.6 3.1 0-.3-.1-.6-.2-1-.2 0-.4 0-.6-.1-.7.6-1.3 1.2-2 1.7-.2-.1-.4-.2-.6-.2l2.4-2.1c-9.1 2.7-14.7 7.3-21.2 11.4.1.1.2.2.2.3.9-.1 1.8-.2 2.8-.3l.1.1-5.1 1.8c.2.1.3.1.5.2-.8.7-1.7 1.4-2.2 1.9-1 .3-1.8.4-2.3.7-2.6 1.4-3.1 3.4-4.9 5-.5.5-.9 1-1.3 1.4.1 0 .2.1.4.1.7-.3 1.3-.6 2-.9.2.1.4.1.5.2-.5 1.8-3.9 2.9-4.7 4.6.1.1.2.2.4.3l5.7-2.4c.1 0 .1.1.2.1-1.1.6-2.2 1.3-3.3 1.9.1.1.2.2.4.3 1.5-.4 3.3-.7 4.4-1.3 2.6-1.5 4.2-3.6 8.8-3.5 2.7 0 3.4-.1 4.8 1 .4.2 2.2.3 2.2.2.8-1.1 2.4-.7 3.8-1-1 .5-1.9.9-3 1.5 2.2 0 4-1.7 5.2-.3-.5 1-1 1.8-1.4 2.5 2.1.4 4.1.7 6.1 1.1 2.4.4 4.8.7 7.2 1.1.4 0 1 0 1.4-.1 1-.2 2.2-.5 3.1-.8.5-.2 1.2-.7 1.1-.9-.6-1.3-2.7-2.2-2.3-3.9 0-.2-.5-.4-.8-.5-1-.5-1.1-1 0-1.6 2-1.1 2-2.4 2-3.7 0-.6.4-1.3 1-1.8 1.8-1.7 3.5-3.5 4.2-5.7l-3.2 1.6c0-.4-.1-.8-.2-1zm232.3-32.7c-.6.2-.8.4-1 .4-1.5.2-3 .4-4.4.6-1.6.3-2.1-.2-2.5-1-.1-.2 0-.5-.1-.9-.9.4-1.7.8-2.5 1.1-1.9.7-2.8 1.9-2.3 3.1.2.5.1 1 .1 1.5-2.5-.2-3.1.3-2.7 1.9.1.5 0 1.2 0 1.7 1 1.4 1 1.7-.6 3.4-.5.5-1.2 1-1.4 1.6-.3.8-1 1.9-.3 2.4 1.2 1 3.2 1.6 4.9 2.3 2 .9 5.4.7 6 3.1 1.4-.7 2.4-1.2 3.2-1.7 1-.8 1.9-1.7 2.8-2.5.3-.3.4-.7.7-1 1.2-1.7 2.2-3.5 5.2-4.7 2.1-.9 3.9-.3 5.9-.4v-1.7c1.9.8 7.1 1.5 9.3.2l2.7-1.5c1-.5 1.6-2.5 1.1-3.2-.5-.8-1.3-1.5-1.5-2.4-.5-2.3-3.9-4.6-7.9-4.5h-4.1c-1.3 0-2.6 0-3.8-.1-.4 0-.9.1-1.2 0-2.7-.5-5.4-1.1-8.1-1.6-.6-.1-1.2-.2-1.8-.4-.1.1-.2.2-.3.2 1.3 1.4 2.9 2.8 4.6 4.1zM71.5 200.9c2.6-.3 4.7-.7 6.9-.9 1.3-.1 2.2.1 2 1.1-.1.4-.3 1 0 1.1 2.1.6.2.8-.2 1.2-.3-.3-.5-.7-.8-.9-.1 0-1.1.2-1.1.3.2.7.6 1.4.9 2.1.7-.2 1.6-.3 2.1-.6 1.2-.9 2.7-1.5 4.6-1.3 2.6.2 4.4-.9 6.5-1.6-.7-.2-1.3-.2-2-.2s-1.3.1-2 .2c0-.1 0-.2-.1-.2 1.4-.3 2.7-.6 4.2-.9-1.9-1.7-4.4-.8-6.5-.8 0-.3-.1-.7-.2-1 1.6-.1 3.1-.2 4.6-.3-.1-1-.2-1.7-.3-2.6-2.8.6-5.4 1.1-7.3 1.5-.8-.5-1.2-1-1.6-1-1 0-2.1.1-3.1.4-1.7.4-3.3 1.1-5 1.3-2.1.2-3.5.7-4.4 1.9-.6.7-1.4 1.1-2.8.7-.5-.1-1.7.1-2.1.4-.6.4-1.2 1.1-1 1.5.3.5 1.4.9 2.2 1.3-2.4.4-3.2-.4-3.3-1.7-2 1-2.7 2.3-1.7 3.2 1 1 2.1.4 3.3-.2l-.6 1.2c1.1-.4 1.7-.5 2.3-.8 1.8-.9 3.5-1.8 5.4-2.6.7-.8 2.2-.8 1.1-1.8zm-17.4 11c-3.2.6-6.3 1.2-8.2-1.4-.8.9-1.4 1.6-2 2.2.8.3 1.5.5 2.5.9-2.7 0-5.7 1.1-6.3 2.1-.6.1-1.4 0-1.6.2-1 .9-2.2 1.9-1.3 3 .7-.2 1.3-.5 2.2-.8-.3.5-.4.7-.5 1 .1 0 .2.1.4.1 1.5-.8 3-1.6 4.6-2.4.1 0 .1.1.2.2-1.1.7-2.2 1.5-3.3 2.3.1.1.2.2.3.2.7-.2 1.4-.3 2.1-.5.6-.2 1.2-.7 1.6-.6 2.2.1 2.9-.9 3.8-1.7 1-.9 1.7-2 3.6-2.5.9-.2 1.5-.8 2.4-1.3-.5-.1-1-.1-1.5-.2.4-.3.7-.5 1-.8zM347.3 134c-2-.6-4.8.9-6.2-.8-2 .2-4.2.4-6.2.8-1.7.3-3.4.9-5.1 1.4-.5.2-.9.5-1.1.9-.2.5-.2 1-.4 1.8-1.2-.3-2.2-.8-3.1-.7-1 .1-1.8.7-2.7 1.2-.1 0-.2-.1-.5-.2 0 .2.2.4.4.4 1.5.3 3.4-.5 4.5.5 0 0 .2-.1.3-.1.9-.3 1.8-.7 2.7-1 3-.9 3.8-.8 5 .6 1.2-.3 2.5-.5 3.5-.9.9-.3 1.9-.6 1.3-1.5-.5-.7 1-1.6 2.2-1.4 2.2.3 3.8-.2 5.4-1zm-44.7 14.4c.5.2 1.1.6 1.9.8 2.7.8 3.5.7 5.7-.4.4-.2.8-.4 1.3-.5 2-.2 1.7-.8 1-1.5-.8-.9-1.2-1.9-1.9-2.9-.5-.1-1.8-.2-2.3-.6-.6-.4-.5-1.2-.7-1.7-1 0-2.1.1-3 .2-.4 2 .2 4.2-2 6.6zm-37.2 36.3c0 1.4.6 2.6-.1 3.6-.9 1.2-.2 1.6 1 2.2.7.4 1.7.8 1.9 1.3.2 1.1 1.5 1.5 2.9 1.8.6.1 1.9 0 2.3-.2.5-.3.8-1 .6-1.4-.5-.9-1.2-1.7-2-2.5-1-1.1-2.7-2-3.2-3.2-.7-1.2-2.2-1.2-3.4-1.6zm-107.9-14c-.2-.5-.4-.8-.7-1.2-.2-.2-.5-.4-.7-.5-2.1-.1-4.3-.1-6.4-.2-.5 0-1.2-.2-1.2-.5-.4-.9-1.7-.8-2.5-.6-.7.2-1.5.9-1.5 1.4-.1 1.4 2 2 4.6 1.5.6-.1 1.3 0 2-.1-.1.4-.1.7-.2 1.1.3.2.8.6 1.4 1 .2 0 .7-.2 1.2-.3-.1.5-.2.9-.3 1.7 1.6-1.3 3-2.3 4.3-3.3zm145-18.6c-5-.3-9.9-.4-14.8 1 .8.2 1.7.3 2.5.3 1.3 0 2.7 0 4 .1 3.4.2 6.8.5 10.3.7.4 0 1-.2 1.1-.3.2-.2.2-.7 0-.8-.7-.6-1.6-1-2.5-1.6h-.5c-.1.2-.1.4-.1.6zm-119.4-21.6c-1.4-.4-3.3-.7-3.2-.9.5-1.7 1-3.3 2-4.9.7-1.1 2.3-2.1 3.5-3.1.3-.2.3-.6.5-.9-.2 0-.4-.1-.6-.1l-1.5 1.2c-.9.7-1.6 1.6-2.6 2.2-2.3 1.4-4 3-4.1 4.9-.1 1.1-.2 2.3-.5 3.8 2.5-.8 4.5-1.5 6.5-2.2zm-57.5 49.1c3.2-.6 4.9-1.9 5.7-3.6.2-.5.1-1.5-.3-1.6-1-.2-2.8-.1-3.4.2-1.3.9-2 2-3 3-.6 0-1.4-.1-2.3-.1-.1.7-.2 1.2-.3 1.8.8-.4 1.3-.6 2.1-1-.3.5-.5.8-.6 1.2.9-.2 2-1.2 2.1.1zM289 115.1c.5-.9 1-1.7 1.3-2.4.2-.5.9-1.2.6-1.5-.9-1.1-2-2.2-3.2-3.1-.5-.3-1.7-.3-2.6-.5.2.5.4.9.7 1.4.5.7 1 1.4 1.4 2.1.1.2-.4.7-.7 1.2.6.7.6 1.5-.9 2.5-.7.4-.7 1.2-1.1 1.9.2 0 .4.1.6.1.7-.7 1.5-1.4 2.2-2.1.7.1 1.4.3 1.7.4zM29.3 219.3c.8 1.1 1.5 1.9 2 2.6 1-.2 2.1-.3 3.6-.5.7-1.7 1.4-3.4 2.1-5.2-.1-.1-.2-.2-.3-.2-2.6 1.1-5.2 2.3-7.4 3.3zm105.1-72.1c2.8.6 3.7-.8 5.3-1.5-.3.5-.7.9-1 1.4.8-.1 1.5-.1 2.1-.2 2.1-.4 1.7-1.4 2-2.2.2-.6.2-1.4 1.6-1.2 1.9.2 2.7-.4 3.2-1.3-5.7.5-9.7 2.5-13.2 5zm-69.9 50.6c-.2-.1-.5-.2-.7-.2-1.2.7-2.3 1.4-3.5 2.1-1.8 1-3.7 1.9-5.6 2.7-.6.3-1.6.3-2.5.4 0 .1 0 .2.1.4.4.1 1 .1 1.1.2 1 .9 2.1.4 3.2-.1 2.2-1.2 4.5-2.4 6.6-3.7.7-.5.9-1.2 1.3-1.8zM34 215.9c1.4-.9 2.7-1.8 4-2.7.1 0 .2.1.3.2-.3.4-.7.8-1 1.2.2 0 .3.1.5.2 1.8-1.5 3.6-2.9 5.4-4.3.1-.1-.2-.5-.5-.6-.2-.1-.7 0-1 .1-1 .3-2 .6-3.3 1 .3.2.9.5 1.7 1-1 .3-1.7.5-2.5.7-3.7.5-4.2 1-3.6 3.2zm357.3-72c3.6-1 3.6-1 3-3v-.6c0-.8.1-1.6.1-2.5-1.2.2-1.9.3-2.2.4-.3 1.9-.5 3.7-.9 5.7zm-182.8-40.7c-.5.3-.9.6-1.3.7-.3.2-.7.2-1.1.4-.9-1.1-2.1 0-2.3.2-1.1.9-1.9 1.9-2.7 2.8-.1.1.4.4.7.6.9-.8 1.6-1.4 2.3-2 0 .1.1.2.1.4.5 0 1.1.1 1.6 0 1.9-.7 3.4-2.2 2.7-3.1zM316 140.6c-1.2.7-2.5 1.5-3.8 2.3 1 1.9 3.3 3.4 6.4 3.7-1.1-.7-1.9-1.2-2.7-1.8 1.6.1 3 .2 4.4.3.1-.1.1-.2.2-.3-1.4-.3-2.8-.7-4.2-1 .1-.5.2-.9.3-1.4h-.4c-.5.5-1 1.1-1.5 1.7-.6-.3-1-.5-1.4-.6.5-1.2 3.3-1.6 2.7-2.9zm-170.9 33.1c.7.6 1.1 1 1.6 1.4.2.2.7.4 1 .3 1.1-.2 2.3-2.4 1.7-2.8l-1.5-1.2c-3.4-.2-2 1.7-2.8 2.3zm-93 33.4c-.2 0-.4-.1-.6-.2-1 .7-1.9 1.5-3 2.3.9 0 1.4.1 2.4.1-1 .4-1.5.6-2.1.8 0 .1.1.2.1.2 1.7-.2 3.4-.5 5.3-.7.2-.6.3-1.3.5-2.1-1.1.2-1.7.2-2.3.3-.1-.2-.2-.5-.3-.7zm264.6-56.6c-.1-.1-.2-.2-.3-.2-.9.1-1.7.2-3.2.3-1.2 1.2-4.6 1.8-6.5 3.2.2.2.5.3.7.5 3.1-1.2 6.2-2.5 9.3-3.8zm-44.1-52c-.1 0-.2.1-.3.1.6.6 1 1.4 1.8 1.9 2 1.1 4.2 2.1 6.5 3.2.1-.1.4-.3.7-.6-1.7-.5-3.5-.8-2.5-2.2-2.2-.8-4.2-1.6-6.2-2.4zm9.1 6c.3.8.5 1.7 1 2.5.2.3.8.6 1.2.9.1 0 .3-.1.4-.2-.1-.3-.2-.6-.4-1 .7-.2 1.4-.4 1.9-.5.2-.6.5-1.2.7-2-1.6 0-3.3.1-4.8.3zm22.9 30.8c-.1-.2-.2-.3-.2-.4 0 0-.2-.2-.3-.1-2.5 1.2-3.6.5-4.2-.9-.1-.2-.5-.3-.8-.3-.3 0-.8 0-1.1.2-.2.1-.5.4-.4.5.1.7 4.1 2.5 5.7 2.5-.5-.2-.8-.5-1.3-.7 1-.3 1.8-.6 2.6-.8zm-60.5-47.4c.2.1.5.1.7.2 2.5-1 4.3-2.2 5.9-3.7.1-.1 0-.4-.2-.5-.2 0-.7 0-.9.1-1.7.9-3.3 1.7-4.9 2.7-.4.3-.4.8-.6 1.2zm146.6 47.2c.5.7 1 1.2 1.3 1.6 1 .2 1.9.4 3.2.7-.2-1.2-.5-2.3-.7-3.3-1.5.4-2.6.7-3.8 1zm-258.3 95.1c-8.5 1.6-10.7 2.5-9.9 4.3.5-.6.7-1.1 1-1.4 1-.3 1.9-.6 2.8-.9.8-.2 1.8-.5 2.6-.5 1.9.2 2.7-.5 3.5-1.5zm-86.5-23.1c-.7.3-2 .8-3.7 1.4 1.9.2 6.7-1 7-1.6.2-.4-.3-.9-.7-1.2-.2-.1-1.3.2-1.9.5-.3 0-.3.4-.7.9zm12-3c-.2 0-.5-.1-.8-.2-1 .5-2.3 1-3.1 1.7-.4.3 0 1 .4 1.4.2.2 1.9.1 2 0 .6-1 1-2 1.5-2.9zm254.3-65.8c0-1.5-.8-2.3-2.7-2.3-.6 1-1.1 1.8-1.6 2.6.1 0 .2 0 .4.1.4-.2.7-.5.9-.5 1.2 0 2.2 0 3 .1zM74.8 210.5c1.7-1.1 3.3-2.1 4.9-3.2-6.8 1-5.8 1.5-4.9 3.2zm-43 2.6c-1.4 1.5-2.6 3-4.1 4.7 3.4-1.2 5.5-3.5 4.1-4.7zm108 15c-3.1-.2-4.4.7-5.9 1.7 3.3.1-.1.9.5 1.5 1.8-1.1 3.4-2 5.4-3.2zm7.7-88.6c-.2-.1-.5-.2-.7-.3-2.2 1.2-4.3 2.5-6.9 4 1.9-.7 3.4-1 4.5-1.6 1.2-.6 2-1.4 3.1-2.1zM40.2 206.9c.1 0 .2.1.2.1 1.5-.6 3.1-1.3 4.8-2-2.5-.3-5.9.8-6.7 2 .6 0 1.2-.1 1.7-.1zm170.1-102.1c1.5-1.1 3-2.1 4.5-3.2-2.9-.1-4.8 1.2-4.5 3.2zm162.5 47.8c.2-.3.3-.5.3-.5l-.6-1.5c-.6.2-1.2.5-1.8.8-.5.2-1 .3-1.8.6 1.5.2 2.7.4 3.9.6zm-101.2 5.7-.3.3c.7.5 1.3 1 2.2 1.3.4.2 1.2 0 1.9 0-.2-.4-.1-1-.5-1.1-1-.3-2.2-.3-3.3-.5zm12.6-40.4c1.5.5 2.5.9 3.7 1.2 0-1-.5-1.8-2.1-2-.4.1-1 .6-1.6.8zm-114.9 7.2c3.5-1.2 4.2-2.1 2.6-2.9-.8.9-1.7 1.9-2.6 2.9zm123.3 5c-.2 0-.4.1-.5.2-.1.9-.2 1.8 2.4 2-.7-.9-1.3-1.5-1.9-2.2zM68.9 197.7c-1.1.5-2.3 1-3.6 1.6 2.1.3 2.1.3 3.6-1.6zm108.2-23.4c.2-.1.5-.2.8-.3-.5-.5-1-.9-1.6-1.4-.1 0-.6.1-.9.2.3.4.7.8 1 1.2.2.1.5.1.7.3zm8.3-1.7c-.7-.4-1.1-.7-1.6-.9l-2.1 1.2c.1.1.1.2.2.2 1.1-.1 2.1-.3 3.5-.5zM53.7 205v-.4c-.5-.1-1.4-.3-1.6-.2-.6.3-1 .8-1.4 1.3.1 0 .3.1.4.2.9-.3 1.7-.6 2.6-.9zm272.6-60.5c-1.6.7-2 1.8-1.1 2.7.4-.9.7-1.8 1.1-2.7zM44.7 203.7c.1.1.2.2.2.4 1.5.1 2.5-.2 2.7-1.4-.9.4-1.9.6-2.9 1zm297-71.2c2.5-.6 3-1.5 1.9-2.2-.7.7-1.2 1.4-1.9 2.2z"
        className="st0"
      />
      <path
        d="M298.8 150.9c-2.7.6-4.8.5-6.9-.3-1.5-.5-3.2-.8-4.8-1.2-.7-.2-1.5-.3-2-.7-2.3-2-5.9-3.1-9.4-4.2-.4.7-.7 1.4-1 2-.2 0-.4.1-.6.1-1.5-2.7-6.8-1.3-9-2.9-.8.8-1.6 1.5-2.3 2.1-.2.2-.6.5-.5.7 1.2 2.2.7 4.6.9 6.9 0 .4.8.8 1.4 1.1 2.5 1.3 4.3 2.9 4.5 5.4-7.1-1.9-14.1-3.4-19-6.3-.4.5-.7 1.2-1.3 1.4-.9.2-2.5.3-2.3-.6-2 0-3.8-.1-6-.1-1.2.7-2.4 1.8-4.1 2.5-1.5.7-3 2.1-5.4 1-1.7 1.8-3.9 2.3-7.1 1.7-.5-.1-1-.2-1.4-.2-.6.1-1.2.3-1.8.5.3.3.5.9 1 1 1.8.4 3.8.7 5.7 1.1l-.3-.6c.1-.1.2-.1.3-.2.7.3 1.3.7 2 1 3.2-.7 1.7-2.2 2-3.5 1.3.8 2.5 1.1 4.5.6 1.8-.5 2.8 0 3.2 1.5.3 1.2 1.5 2.3.8 3.8-1.2 2.4-1.6 4.8-2.9 7.2-1.1 2.1-1.5 2.1-4.4.8-2.7-1.2-5.7-1.9-9.2-1.9-.4 0-.8-.1-1.1-.2-3-1.5-7-1.6-10.5-2.3-.2 0-.5 0-.7-.1-.6.5-1 1-1.6 1.5-.7-1.4-1.8-1.6-4.4-.6.4-.7.5-1.2 1-1.6.9-.7 1-1.2.3-1.8-1.1-1-2.2-2.1-3.4-3.2-2.1.7-1.6 2.7-4.8 2.2.4 1.5-1.3 1.5-2.7 1.7-1.9.2-4.4-.6-5.1-1.8-.7.4-1.4.7-1.8 1.1-.3.3-.3.7-.5 1.3.5 0 1.9 0 2.6.3s.7 1.1 1.1 1.8c-.5.1-1.1.3-1.4.2-2.3-.5-4.5-1.1-6.8-1.6-1-.2-2.3 0-3.5 0-1.3 0-2.6.1-3.9.2-.8 0-1.6.1-2.5.2-.2 0-.5.5-.4.5.5.3.9.6 1.5.7 2.3.3 4.7.2 7.1-.2.7-.1 1.5-.1 2.2.1-.5.2-1 .3-1.4.5.7.6 1.3 1.1 1.9 1.6-.2.1-.3.2-.5.3-1.2-1.4-3.4-.9-5.4-.8-1.8.1-3.6.1-5.4.1-1.2 0-2 0-2.2.9-.2.8-.5 1.7-2.3 2.1-1 .2-1.2.7-.4 1.2.4.3.5.9.5 1.3-.3 1-.5 1.9 1 2.8 1 .6 1.2 1.8-.1 2.8-.6.5-1.2 1-1.6 1.4-1.3.3-2.5.6-3.7.9-.1.1-.2.3-.3.4-2.1-1.2-4.3-2.4-6.3-3.7-.3-.2.2-1 .7-1.3 1.4-1 3-1.8 4.6-2.7-1.1-2.2-4.2-2.2-7.6-1.5-.5-1.1 3.3-1.2 1.4-2.3.5-.4 1.1-.7 1.2-1 .2-1.3.1-2.7.5-4 .2-1 1-1.9 1.8-3.2-.3-.8-5.5-.5-2.2-3l1.5 1.5c.3.2.7.6 1.1.5.7 0 1.6-.2 2.1-.5 1.9-1.2 3.7-2.4 5.5-3.6.5-.4.7-.9 1.1-1.4-2.7-2-2.7-2.2.7-2.8-.6-.4-1-.8-1.5-.8-2.2-.1-1.4-.7-.5-1.2 1-.7 2-1.5 3.1-2.2l-.6-.3c-.6.3-1.3.6-1.8 1-.7.5-1 1.2-1.8 1.6-.9.5-2.6 1.1-3.2.9-1.2-.3-2.8-.8-2.4-2 .3-.9.5-1.8.7-2.7-2 .1-3.2 1-2.9 2 .2.6 0 1.3 0 2 0 .6-.4 1.3 0 1.8.2.3 1.3.7 2 .7 1.9-.2 2 .4 1.8 1.2-.1.4-.3.9 0 1 2.2 1 .5 2.1.3 3.3-2.3-.4-4.4-.7-6.7-1.1-.3.6-.6 1.1-.9 1.7-.5 1-2 1.5-3.6 1-3.6-.9-4.1-2-2.3-4.4.7-.9 1-1.9 1-2.9.1-1.1-.3-2.2-.5-3.3-.1 0-.4.2-.7.3-.2 0-.3-.1-.5-.2.5-.4.9-.8 1.3-1.2.1-.1.4-.2.4-.3-.3-1.6 2.2-2.5 3.2-3.8.3-.4.7-.9 1.2-1.2.2-.2.7-.3 1.2-.4 1-1.1 1.9-2 4.8-1.9 1.1 0 2.5-1 3.7-1.4 2.1-.7 4.2-1.4 6.3-2 .6-.2 1.3 0 2-.1-.1.4 0 1-.4 1.3-1.4.8-2.9 1.6-4.5 2.3-.4.2-1 .3-1.4.5 1.1.1 2.2.4 3.2.4 1.2 0 2.4-.3 3.6-.5 0-.2-.1-.3-.1-.5-.5 0-1.1.1-1.7.2-.1-.1-.2-.1-.2-.2.9-.4 1.9-.8 2.8-1.2-1-1.1-.5-2.1 1.9-3.3-.8-.4-1.7-.7-2.8-1.2 1.2-.5 1.9-.7 3.1-1.2-.2.6-.4 1-.5 1.3.2 0 .5.1.5 0 .6-.3 1.7-.6 1.7-.9 0-1.2.9-2.3 2.2-3.2 1.9-1.2 4-2.4 6-3.6.3-.2.5-.5.9-1-1.5.2-2.4.2-3.4.4 0-.1-.1-.2-.1-.2 3.5-1.2 7.1-2.4 10.7-3.6-1.6-.2-3.2-.5-4.6-.6.2-1.2.1-2 .7-2.8.4-.5 1.6-.9 2.5-1.4 1.2 1.1 2.5 2.1 4.8 2.5.5.1.8.6.8 1 0 .5-.3 1.1-.5 1.6 2.1-.8 2.5-2.1.8-3.5 1-.3 1.9-.6 2.7-.9-.5-.6-.8-.6-1.8 0-1.2.7-2.3 1.9-3.6.2-.2-.2-1-.2-1.5-.2.2-.6.4-1.1.5-1.7.5.2.9.5 1.3.7.4-.5.8-.9 1.2-1.4-.3 0-.7 0-1.1.1l-.2-.2c1.8-.6 3.6-1.3 5.9-2.1-1.7.1-2.7.1-4.3.2 2.1-1.4 3.6-2.5 5.2-3.6-.5 0-1-.1-1.4-.1 1-2 3.2-3.7 5.8-5.1 2.2-1.2 4-2.5 4.5-4.3.4-1.5 2.5-1.9 4.5-2.3.4-.1.9-.2 1.1-.5 1.2-1.4 4.3-2.3 6.5-1.8-1.2 1.5-2.4 2.9-3.7 4.4.2.1.4.1.7.2.7-.7 1.3-1.5 2.1-2.2.4-.4 1.2-.6 1.7-.9 1.7-.9 3.3-2.2 5.2-2.5 2-.3 3.5-.9 3.7-1.8.4-2 3.3-2.3 5.2-3.4 1.3.4 2.1 1.5 3.9.7.5-.3.6-.9.9-1.3 1.9-1.1 3.8-2.2 5.8-3.4-.5-.2-.7-.4-1.4-.8 2.7-1.4 5-3.3 8-3.9 4.1-.8 6.4-2.6 9.5-4 .2-.1.4-.2.5-.2 3.7.2 4.9-2 7.4-2.9.4-.2.7-.5.9-.8.4-.5.7-1.2 1.8-.3.1.1 1.3-.2 1.7-.4.2-.1-.2-.6-.4-1.1 4.1-2.6 9.2-4.5 15.6-5.2.1-1.3 2.4-1.2 4.1-1.6-.1.8.1 1.7-.3 2.4-.2.4-1.5.7-2.3 1-.9.3-1.9.6-2.9.8-.6.1-1.2.1-1.5.1-.2.9-.5 1.7-.7 2.6.8.1 1.9.3 3.3.5-3.9 1.7-4.5 3.9-5.4 6-.9.3-2 .6-2.5 1-2.6 2.4-2.6 2.5-2.1 3.9 1.2.3 2.1.5 3.2.8-1 .8-1 1.4 0 1.5.1 1.7.2 3.3.4 5.2-2.2-.8-4.5-1.4-6.1-2.4-1.1-.7-1.5-1.8-.7-3 .7-1.1.2-2.4.9-3.5.5-1 .2-1.5-.8-2.1-.2 1-.5 1.9-.8 3-2-.6-3.4-.1-3.7.8-.3.9-1.4 2.1.6 2.8-1.2.5-1.5 1.8-3.7 1.7-.4 0-.9.4-1.2.6-1.1.7-2 1.5-3.2 2.2-1.2.7-2.2 1.4-2.3 2.5-.1 1.7-.6 3.4-.9 4.8.7 0 1.5.2 2.2.1.4 0 .8-.2 1.1-.5.5-.4.8-1 1.4-1.1 1.5-.3 2.4.3 3.2.9 3.3 2.3 3.7 5.2 4.2 8.2.1.5-.4 1.2-1.1 1.5-1.8.8-1.4 1.6-.9 2.5.3.7.2 1.5.3 2.2 5.4.2 7.8 2 4.4 3.9-1.1-.7-2.2-1.4-3.4-2.2-.5.2-1.1.3-1.8.5-.4-.4-.8-.7-1.2-1.1-2 .2-2.2 1.1-3 2.1-.4-.5-.7-.9-1.3-1.5-.3.4-.7.6-.7.9-.3.7-.6 1.5-.7 2.2 0 .2.5.5 1 .5.7.1 1.4 0 1.7 0 1-.6 2-1.2 3.1-1.9-.2 1.3-.4 2.3-.6 3.2 2.7.5 5.3.5 7 2 1.5 1.2 2.1 1 3.1 3.1.6 1.4 1.1 2.8 1 4.2 0 .9-1.3 1.8-2 2.7-.4.5-.6 1.1-.9 1.6-1-.3-2-.3-2.3.8-.5 2.3 2.2 3.7 6.1 3 .7-.2 1.3-.8 2-1.2.2 0 .3.1.3.1-.2 1.4 1.2 2.2 2.8 3.1.3.2.5.4.5.6-.1 1.2-.4 2.3-.5 3.2-2.7-.1-5.7-.2-8.9-.4 1.5 2 3.6 3.3 6.9 3.9 1 .2 2.3-.1 3.3 0 1.2.2 2.2.5 3.2.8 1.8.1 2.8.5 4.1 1zM28.5 241.1c.2.1.5.2.7.4-.9.8-1.7 1.6-2.9 2.7-.4-.7-.7-1.2-.9-1.7-.2 1-1.3 1.9 0 2.8.2.2.1.7 0 1-.5 1.2-1 2.3-1.4 3.5 0 .2.5.4.5.4-1.2.9-2.4 1.8-3.7 2.8.4-.7.7-1.3 1.1-2 .4-.6.9-1.2 1.1-1.9.2-.6 0-1.2 0-1.8h-.7c-1.1.6-2.2 1.3-3.3 2-.4-.2-.9-.4-1.4-.5-1.4 1-4.2 1.5-4.9.8-1.5-1.3.7-2.3 2-3.5-.5-.2-.9-.4-1.3-.5-1.7 1.2-3 2.7-6 2.5-.1-1.7 2.7-2.4 4.7-3.3-.2-.1-.3-.2-.5-.3-2.1.5-4.2 1.1-6.3 1.7 0-.2-.1-.4 0-.5 1.6-2 3.1-4 5-5.9.7-.7 2.2-1.2 3.5-1.8 3.8-1.7 7.7-3.5 11.6-5.2.9-.4 1.9-.7 2.9-1 .9-.3 1.4-.5 1.8-1.3.6-1.1 2.4-2.1 3.7-3.2.5-.4 1-.7 1.9-1.2.7-.1 2.5.4 2.3-1h1c.8-.6 1.4-1.1 2.1-1.5 1.7-.8 3.5-1.5 5.3-2.2.5-.2 1.1-.1 1.8 0 2.4-.7 3.2-2.7 6.7-2.8-.7-.2-1.4-.3-2-.5 2.2-1 4.4-2.1 6.6-3.3.6-.3 1.1-.8 1.4-1.3.6-.8 1.5-1 2.8-.7.2-.5.4-1.1.6-1.8-.8 0-1.6.2-2.4.2-.7 0-1.5-.2-2.2-.2l.9-1.5s.1-.1.2-.1c2.2-.1 4.3-.1 6.5-.2.2-.5.2-1.7 2.1-.4.2.1.9.1 1.2 0 .3-.1.6-.4.5-.6-.2-.7-.5-1.3-.8-2.1 1-.4 2.1-.8 3-1.2.9.5 1.5.8 2.3 1.3-.2.4-.5 1-.7 1.6.2 0 .4.1.6.1-.9.2-1.8.4-2.7.5.2 1.2.7 2.2-.3 3.5-1 1.2-.6 2.8-.5 4.1.1.5.6 1.6 2.7.8.6-.2 1.7.1 2 .1 3.8-1.1 7.3-2.1 10.6-3.1 1.7.4 3.5.8 5.2 1.2 1.4-1.5 1.4-1.5-2.3-2.7 1.2-2.7 1-2.9-2.7-2.9-1.5-.9-2.7-1.5-4-2.3 2-1.6 4.8-2.5 8.4-2.9.8.7 2.5 1 3.8.3.8-.5.5-1.6.8-2.7 1.8.3 3.9.8 6 1.1.6.1 1.6.2 2.1 0 1.5-.7 3.1-.6 4.7-.8.7-.1 1.6 0 2 .2.3.2.1.7 0 1.1-.7 1.9-2.5 3.4-5.1 4.7-1.2.6-1.3 1.9-1.7 2.9 1.6-.7 1.2-2.3 4.1-2.5-.2.4-.4.7-.6 1.2 1.5 0 3 .1 4.4-.1.6-.1.9-1 1.4-1.7 0 0 .5.1 1.2.2-.8 1.4-1.6 2.7-2.4 4.1-.1 0-.3 0-.4.1-.2-.5-.5-.9-.7-1.3-2.7 1.7-3 3.8-.5 4.8-3.7 1.5-.8 3-.4 4.7-.8-.2-1.3-.4-1.9-.5 0 0-.1.1-.2.1.9.3 1.8.7 2.7 1 1.2.4 1.7.9 1.4 1.9-.4 1-.5 2.1-.3 3.1.1.5.9 1.1 1.7 1.4 1.2.5 2.7.8 4 1.3.7.3 1.1.8 1.7 1.2-.2.1-.3.2-.5.4-1.5-.3-3.1-.6-4.5-1.1-1.2-.4-1.9-.7-3.2.1-1.2.7-3 1.2-4.9 1.9 2.2.6 1.6 1 .3 1.4-3.6 1-4.5 3.2-1.7 4.7 1.7 1 3.2 2 5 2.9.7.4 1.9.6 2.9.6.9 0 2.2-.2 2.8-.6 1-.6 2.2-1.4 1.1-2.4-.3-.2-.6-.5-1.1-.9.7-.6 1.4-1.2 2.2-1.9 1.6 1.5 3 2.8 4.5 4.3.7-.5 1.2-.9 1.8-1.3 1.5-1.1 3-1.1 4.3-.1 1.4 1.1 2.6 2.4 5.6 2.1.5 0 1.4-.3 1.5-.5.5-1.2 1.7-1.5 3.6-1.4.7 0 1.4-.1 2.5-.2-2-1.7-.5-3.5.5-5.2.8.5 1.6 1.1 2.4 1.7.1 0 .2-.1.3-.2-.5-.7-.9-1.3-1.4-2 2.8-.5 5.5-.8 6.8-2.6.2-.2.8-.5 1.2-.5 2.2-.1 4.3-.2 6.5-.3.9-.1 2-.2 2.6-.5 3.9-1.8 5.4-1.9 9.6-.7.9.2 2.3.2 3.3 0 1.6-.4 2.8-1.2 4.9-1 .7.1 1.7-.8 2.7-1.2 1-.4 2-.7 3-1 1.2-.3 2.5-.4 3.7-.6 1.3-.2 3.6.5 3.9 1.4.4 1.2.5 2.5.9 3.8.1.4.3.8.8 1 2.9 1.2 3.8 3.2 5 5 .2.3-.1.7-.3 1.1-.7.9-1.5 1.7-2.2 2.7-.7 1-.5 1.7.7 2.6 1.2 1 1.6 2.3 2.4 3.6-.6-.1-.9-.1-1.5-.2 1.3 2 2.5 3.9-2.9 5 2 .3 4.5 0 4 1.5-.3 1-1.5 1.9-2.4 3 1.2.7 1.2 1.6-1.6 2.2 3.5.7 3.4 2.3 2.7 4 .8-.1 1.2-.1 1.6-.2 1.3-.4 1.6 0 1.5.6-.1.4-.2.8-.2 1.1.6 2.3 2 2.7 6.3 1.9-1.4 2-6.1 3.9-8.8 3.5-3.1-.4-5.4-1.7-5.1-3.1-.5.1-.9.2-1.2.3-.5-.7-1-1.4-1.6-2.3l1.6.4v-.2c-1-.6-1-1.9-3.4-1.4-.1 0-.3 0-.4-.1-1.1-1-2.6-1.8-3.2-2.8-.9-1.7-2.8-2.7-4.5-4-2.5-1.8-4.7-3.6-7.1-5.4-1.3-1-3.3-1.4-5.3-.8-3.5 1-6.4.2-9.5-.2-2.4-.4-5-.5-7.3-1-1.1-.2-1.7-1-2.4-1.7-2-.5-2.8-1.3-2.9-2.7-.1-.9-.4-1.7-1-2.5-.5-.6-1.5-.9-3-.7-1.3.2-2.8-.2-4.7-.5.4.7.7 1.1 1 1.7-2.1.2-4.4.6-6.6.8-.6 0-1.1-.4-1.8-.5-1.8-.2-3.5-.2-5.4.3-1.4.4-3 .5-4.6.6-1.2.1-2.3.1-2.7 1-.1.2-.7.6-1.2.7-2.7.5-5.3 1.1-8 1.5-1.6.2-3.1.2-4.2-.7-.5-.4-1.6-.6-2.6-.7-3.1-.2-6.3-.4-9.4-.6-1.2-.1-2.4-.5-3.6-.6-.7-.1-1.5 0-2.3 0l-.3.6 13.2 2.1c-.1.2-.2.3-.3.5-1.6-.2-3.2-.5-4.9-.7-.5-.1-1.1 0-1.7 0-1 .1-2.2.6-2.4-.5 0-.1-.5-.2-.9-.2-1.7-.2-3.6-.4-5.3-.7-1.6-.3-3.1-.4-4.8.1-.6.2-1.5 0-2.2-.1-4.7-.5-9-1.4-11.7-3.8-.9-.8-2.4-1.3-3.8-2 .2-.2.7-.6 1-.9 0-.1 0-.2-.1-.4-1.6.2-3.3.3-4.8.7-2.6.6-4.9.3-7.2-.1-1-.2-1.7-.4-2.3.5-.4.6-3.1.2-3.5-.5-.3-.7-1-.7-1.9-.4-2.3.7-4.6 1.4-6.8 2.2-2.2.6-4.1 1.5-6.3 2.4z"
        className="st0"
      />
      <path
        d="M177 187.8c2.2-.4 3.3-1.7 4.5-3.1 1.2-1.5 3.4-2.7 5.2-4 .9-.7 2-1.2 3.2-1.9.7.8 1.2 1.4 1.9 2.3 1-.3 2-.8 3.1-1.1 1-.3 2-.4 3-.6 1.4-.3 2.8-.7 4.2-1.1.2-.1.2-.6 0-.9-.9-1-.6-1.6 1.2-2.2 1.6-.5 3.2-.9 4.7-1.5 1-.4 1.8-1 2.5-1.5.7-.6 1.2-1 2.6-.7 2.1.5 4.2 1 6.3 1.4 2.5.6 5.2.7 7.7 1.6 1.9.7 4.7.5 7.2.7 1.5.1 2.9.3 4.4.4 1 .1 2.1.3 2.9-.6 1-1.2 2.4-2.2 3.6-3.5.3.2.8.3 1 .6 1.7 2.3 3.2 4.5 2.8 7.3-.3 2.2.5 4.4.9 6.6 0 .1.1.2.2.3 1.6.6 3.4 1.1 4.9 1.8 1.8.7 3.6 1.5 5.2 2.4.5.3.1 1.1 0 1.7-.1.4-.5.8-.6 1.2-.2 1.4-.5 2.7 2.6 3.2 1.4.2 2 1.1 1.1 2-.5.6-.2.9.4 1.5.9.7 1.3 1.8 1.5 2.8.3 2 .5 3.9-2.7 5.5-.9.4-1.5 1.1-2 1.7-.9 1-2.1.9-3.4.5-1.5-.4-3-1.1-4.6-1.2-2.5-.1-4.2-.9-6.3-1.5-1.8-.5-3.6-1.2-5.6-1.4-3.5-.4-4.7-2-5.6-3.7-.4-.7-.7-1.2-2-1.5-1.7-.4-3.3-1.1-5-1.6-.9-.2-2-.5-3-.5-3 .2-4.5-.7-5.8-2.1-1.2-1.4-2.6-1.3-4.6-.1-.5.3-1.5.6-1.9.5-2-.6-3 .2-3.7 1-1.2 1.5-2.3 3-4.8 3.9-.2.1-.4.2-.5.4-.7 1.2-2 2.1-4.4 2.1h-5.6c-1.3 0-2.5-.2-3.8-.1-3 .2-4.4-.8-5.7-2-.9-.8-2.1-1.7-3.5-2-1.5-.3-1.7-1-2.1-1.6-.6-1.2-1-2.4-1.5-3.7 0-.1-.2-.3-.1-.3 1.8-1.4 1.1-2.6-.5-3.7-.4-.3-.4-.8-.4-1.3.6-.5.8-1.3.9-2.4zm168.8-45.5c-1.7-1.4-3.3-2.7-4.9-4 .1-.1.2-.2.3-.2.6.1 1.2.2 1.8.4 2.7.5 5.4 1.1 8.1 1.6.3.1.8 0 1.2 0 1.3 0 2.6 0 3.8.1 1.4 0 2.7.1 4.1 0 4.1-.1 7.4 2.2 7.9 4.5.2.8.9 1.6 1.5 2.4.5.7-.1 2.7-1.1 3.2l-2.7 1.5c-2.2 1.4-7.4.6-9.3-.2v1.7c-2 .1-3.8-.5-5.9.4-3 1.2-4 3-5.2 4.7-.2.3-.3.7-.7 1-.9.9-1.7 1.7-2.8 2.5-.7.6-1.8 1-3.2 1.7-.6-2.4-4-2.2-6-3.1-1.7-.7-3.7-1.4-4.9-2.3-.6-.5 0-1.6.3-2.4.2-.5 1-1 1.4-1.6 1.6-1.7 1.6-2 .6-3.4 0-.6.1-1.2 0-1.7-.3-1.6.3-2.1 2.7-1.9 0-.5 0-1-.1-1.5-.5-1.2.4-2.5 2.3-3.1.8-.3 1.6-.7 2.5-1.1 0 .3 0 .6.1.9.3.7.8 1.2 2.5 1 1.5-.2 2.9-.4 4.4-.6.5-.1.7-.2 1.3-.5zM71.5 200.9c1.1 1-.5 1.1-1.3 1.5-1.9.8-3.6 1.7-5.4 2.6-.5.2-1.2.5-2.3.8.3-.5.4-.8.6-1.2-1.2.5-2.4 1.1-3.3.2-1-.9-.3-2.2 1.7-3.2.1 1.3 1 2.1 3.3 1.7-.7-.4-1.8-.8-2.2-1.3-.2-.4.5-1.1 1-1.5.5-.3 1.7-.5 2.1-.4 1.5.4 2.2 0 2.8-.7 1-1.1 2.4-1.6 4.4-1.9 1.7-.2 3.3-.9 5-1.3 1-.2 2.1-.4 3.1-.4.5 0 .8.5 1.6 1 2-.4 4.5-.9 7.3-1.5.1.9.2 1.7.3 2.6-1.5.1-3 .2-4.6.3.1.4.1.7.2 1 2.1 0 4.6-.9 6.5.8l-4.2.9c0 .1 0 .2.1.2.7-.1 1.3-.2 2-.2s1.3 0 2 .2c-2.1.7-3.9 1.8-6.5 1.6-1.8-.1-3.3.4-4.6 1.3-.5.3-1.4.4-2.1.6-.3-.7-.7-1.4-.9-2.1 0 0 1-.4 1.1-.3.3.2.5.5.8.9.4-.4 2.3-.5.2-1.2-.2-.1 0-.7 0-1.1.2-.9-.7-1.2-2-1.1-1.9.5-4.1.8-6.7 1.2zm-17.9-3.4c0-.2-.2-.6 0-.7 1.2-.9 2.4-1.7 3.4-2.6-3.6 1.4-5.6 4.1-10.9 4.2 1.7-1.2 3.3-2.4 4.9-3.5 1.2-.9 2.2-1.8 3.6-2.6 3.5-2.2 6.9-4.4 10.5-6.4 1.2-.7 2.7-1.2 4.7-2-1.7 2.4-2.7 4.5-4.7 6.2-2.1 1.9-.7 4-3 5.9.7 0 1.2.1 2 .1-3.2 1.9-6.2 3.7-9.2 5.4-.2-.1-.4-.2-.5-.2.6-.8 1.2-1.7 1.9-2.6-.7.2-1.4.3-2.1.5-.1-.1-.3-.2-.4-.2 1-.7 2-1.3 3.2-2.1-1.3.3-2.4.6-3.5.8l.1-.2zm.5 14.4c-.3.2-.7.5-1.1.9.5.1 1 .1 1.5.2-.9.5-1.5 1.1-2.4 1.3-2 .5-2.6 1.6-3.6 2.5-.9.8-1.7 1.8-3.8 1.7-.5 0-1 .5-1.6.6-.7.2-1.4.3-2.1.5-.1-.1-.2-.2-.3-.2 1.1-.7 2.2-1.5 3.3-2.3-.1 0-.1-.1-.2-.2-1.5.8-3 1.6-4.6 2.4-.1 0-.2-.1-.4-.1.1-.2.3-.5.5-1-.9.3-1.5.6-2.2.8-1-1.1.2-2.1 1.3-3 .2-.2 1-.2 1.6-.2.6-1 3.7-2.2 6.3-2.1-1-.3-1.6-.6-2.5-.9.6-.7 1.2-1.3 2-2.2 2 2.4 5.1 1.9 8.3 1.3zM347.3 134c-1.6.7-3.2 1.3-5.3 1-1.3-.2-2.7.7-2.2 1.4.6.9-.5 1.2-1.3 1.5-1.1.4-2.3.6-3.5.9-1.2-1.3-2-1.5-5-.6-.9.3-1.8.6-2.7 1-.1 0-.3.1-.3.1-1.2-1-3.1-.2-4.5-.5-.2 0-.4-.2-.4-.4.2.1.4.2.5.2 1-.5 1.8-1.1 2.7-1.2.9-.1 2 .4 3.1.7.2-.8.2-1.3.4-1.8.2-.3.6-.7 1.1-.9 1.6-.5 3.3-1.1 5.1-1.4 2.1-.4 4.2-.6 6.2-.8 1.3 1.7 4.1.3 6.1.8zm-44.7 14.4c2.2-2.4 1.6-4.5 1.9-6.7.9 0 2-.1 3-.2.2.6.1 1.3.7 1.7.5.4 1.8.5 2.3.6.7 1 1.1 2 1.9 2.9.7.8 1 1.3-1 1.5-.5 0-.9.3-1.3.5-2.2 1.2-3 1.2-5.7.4-.7-.2-1.3-.5-1.8-.7zm-37.2 36.3c1.2.4 2.7.4 3.3 1.7.5 1.2 2.1 2.1 3.2 3.2.8.8 1.5 1.6 2 2.5.2.4-.1 1.1-.6 1.4-.5.3-1.7.4-2.3.2-1.4-.3-2.7-.7-2.9-1.8-.1-.5-1.1-.9-1.9-1.3-1.2-.6-1.9-1-1-2.2.8-1.1.2-2.3.2-3.7zm-107.9-14c-1.3 1-2.7 2.1-4.5 3.5.1-.8.2-1.2.3-1.7-.5.1-1 .2-1.2.3-.6-.4-1-.7-1.4-1 .1-.4.1-.8.2-1.1-.7 0-1.3 0-2 .1-2.6.5-4.7-.1-4.6-1.5 0-.5.8-1.2 1.5-1.4.8-.2 2.2-.2 2.5.6.1.2.8.5 1.2.5 2.1.1 4.3.1 6.4.2.3 0 .6.2.7.5.5.1.7.5.9 1zm145-18.6c0-.2.1-.4.1-.6h.5c.8.5 1.7 1 2.5 1.6.2.2.2.6 0 .8-.1.2-.8.4-1.1.3-3.4-.2-6.8-.5-10.3-.7-1.3-.1-2.6 0-4-.1-.9 0-1.7-.1-2.5-.3 4.9-1.4 9.8-1.3 14.8-1zm-119.4-21.6c-2 .7-4 1.4-6.4 2.2.2-1.6.3-2.7.5-3.8.2-1.9 1.8-3.5 4.1-4.9 1-.7 1.7-1.5 2.6-2.2l1.5-1.2c.2 0 .4.1.6.1-.2.3-.2.7-.5.9-1.2 1-2.7 2-3.5 3.1-1 1.6-1.6 3.3-2 4.9-.2.2 1.7.5 3.1.9zm-57.5 49.1c-.1-1.2-1.2-.2-2.1 0 .2-.3.3-.6.6-1.2-.8.4-1.3.6-2.1 1 .1-.7.2-1.2.3-1.8.9 0 1.7.1 2.3.1 1-1 1.7-2.2 3-3 .6-.4 2.3-.4 3.4-.2.4 0 .5 1.1.3 1.6-.8 1.5-2.5 2.8-5.7 3.5zM289 115.1c-.3-.1-1-.3-1.7-.5-.7.7-1.5 1.4-2.2 2.1-.2 0-.4-.1-.6-.1.3-.6.4-1.5 1.1-1.9 1.5-.9 1.5-1.7.9-2.5.3-.5.9-.9.7-1.2-.3-.7-.9-1.4-1.4-2.1-.3-.5-.5-.9-.7-1.4.9.1 2.1.1 2.6.5 1.3 1 2.4 2 3.2 3.1.3.4-.3 1-.6 1.5-.3.9-.8 1.6-1.3 2.5zM29.3 219.3c2.2-1 4.8-2.2 7.3-3.4.1.1.2.2.3.2-.7 1.8-1.4 3.5-2.1 5.2-1.5.2-2.5.4-3.6.5-.5-.6-1-1.4-1.9-2.5z"
        className="st0"
      />
      <path
        d="M53.5 197.5c.2 2-1.5 3.7-4.2 4.1-.4 0-.8-.1-1.5-.2-.6.2-1.6.6-2.7 1-1.2-1.7-.6-2.4 2.2-3 2.2-.6 4.3-1.3 6.2-1.9.1 0 0 0 0 0zm80.9-50.3c3.5-2.5 7.5-4.5 13.1-5.2-.5 1-1.2 1.5-3.2 1.3-1.4-.1-1.5.7-1.6 1.2-.2.9.2 1.9-2 2.2-.6.1-1.3.1-2.1.2.4-.5.7-.9 1-1.4-1.4.9-2.3 2.4-5.2 1.7zm-69.9 50.6c-.5.6-.6 1.3-1.4 1.7-2.1 1.3-4.3 2.5-6.6 3.7-1 .5-2.1 1-3.2.1-.2-.2-.7-.2-1.1-.2 0-.1 0-.2-.1-.4.8-.1 1.8-.1 2.5-.4 2-.8 3.8-1.8 5.6-2.7 1.2-.7 2.4-1.4 3.5-2.1.3.1.6.2.8.3zM34 215.9c-.6-2.1 0-2.7 3.5-3.4.8-.2 1.5-.4 2.5-.7-.8-.5-1.3-.7-1.7-1 1.3-.4 2.3-.7 3.3-1 .3-.1.8-.2 1-.1.2.1.6.5.5.6-1.7 1.5-3.6 2.9-5.4 4.3-.2 0-.3-.1-.5-.2.3-.4.7-.8 1-1.2-.1 0-.2-.1-.3-.2-1.2 1-2.5 2-3.9 2.9zm357.3-72c.3-2 .6-3.8 1-5.7.3 0 1-.2 2.2-.4 0 .9-.1 1.7-.1 2.5 0 .2-.1.4 0 .6.5 2 .5 2-3.1 3zm-182.8-40.7c.7 1-.8 2.4-2.8 3-.5.1-1 0-1.6 0 0-.1-.1-.2-.1-.4-.7.6-1.4 1.2-2.3 2-.3-.2-.8-.5-.7-.6.8-1 1.7-2 2.7-2.8.2-.2 1.5-1.2 2.3-.2.4-.1.7-.2 1.1-.4.5 0 .8-.3 1.4-.6zM316 140.6c.6 1.3-2.2 1.7-2.9 2.8.3.2.8.4 1.4.6.6-.7 1-1.2 1.5-1.7h.4c-.1.5-.2.9-.3 1.4 1.5.3 2.9.7 4.2 1-.1.1-.1.2-.2.3-1.4-.1-2.8-.2-4.4-.3.9.5 1.7 1 2.7 1.8-3-.3-5.3-1.8-6.4-3.7 1.5-.7 2.8-1.4 4-2.2zm-170.9 33.1c.8-.7-.6-2.6 2.8-2.4.6.5 1 .9 1.5 1.2.6.5-.6 2.7-1.7 2.8-.3 0-.8-.2-1-.3-.5-.3-.9-.7-1.6-1.3zm-93 33.4c.1.2.2.5.2.9.6-.1 1.2-.2 2.3-.3-.2.8-.4 1.5-.5 2.1-2 .2-3.6.5-5.3.7 0-.1-.1-.2-.1-.2.6-.2 1.2-.5 2.1-.8-.9 0-1.4-.1-2.4-.1 1.1-.9 2.1-1.6 3-2.3.4-.1.6-.1.7 0zm264.6-56.6-9.3 3.9c-.2-.2-.5-.3-.7-.5 1.9-1.5 5.3-2.1 6.5-3.2 1.5-.2 2.3-.2 3.2-.3.1-.1.2 0 .3.1zm-44.1-52c2 .8 4.1 1.6 6.2 2.5-1 1.3.7 1.7 2.5 2.2-.3.2-.6.5-.7.6-2.2-1.1-4.5-2.1-6.5-3.2-.8-.5-1.2-1.2-1.8-1.9 0-.1.1-.2.3-.2zm9.1 6c1.4-.1 3.2-.3 4.9-.4-.3.9-.5 1.4-.7 2-.5.2-1.2.3-1.9.5.2.4.3.7.4 1-.1 0-.3.1-.4.2-.4-.3-1-.5-1.2-.9-.5-.8-.8-1.6-1.1-2.4zm22.9 30.8c-.8.2-1.7.5-2.6.7.5.2.8.5 1.3.7-1.7 0-5.6-1.8-5.7-2.5 0-.2.2-.4.4-.5.3-.1.7-.2 1.1-.2.3 0 .7.2.8.3.7 1.3 1.8 2 4.2.9 0 0 .2.1.3.1.1.2.1.3.2.5zm-60.5-47.4c.2-.4.2-.9.6-1.2 1.5-1 3.2-1.8 4.9-2.7.2-.1.7-.2.9-.1.2 0 .4.4.2.5-1.6 1.4-3.5 2.7-5.9 3.7-.2 0-.4-.1-.7-.2zm146.6 47.2c1.1-.3 2.3-.7 3.8-1.1.2 1 .5 2.1.7 3.3-1.3-.3-2.2-.5-3.2-.7-.3-.3-.8-.8-1.3-1.5zm-258.3 95.1c-.8 1-1.6 1.7-3.5 1.5-.8 0-1.7.3-2.6.5-.9.2-1.7.5-2.8.9-.2.3-.5.7-1 1.4-.7-1.8 1.4-2.7 9.9-4.3zm-86.5-23.1c.3-.5.4-.8.7-1 .6-.2 1.7-.6 1.9-.5.5.3.9.8.7 1.2-.2.7-5.1 1.8-7 1.6 1.7-.5 2.9-1 3.7-1.3zm12-3c-.5 1-.9 1.9-1.5 2.8-.1.1-1.7.2-2 0-.4-.3-.7-1.1-.4-1.4.8-.7 2-1.1 3.1-1.7.2.2.5.2.8.3zm254.3-65.8c-.9 0-1.9-.1-3.1-.1-.1.1-.5.3-.9.5-.1 0-.2 0-.4-.1.5-.8 1-1.6 1.6-2.6 2 0 2.8.8 2.8 2.3zM74.8 210.5c-.9-1.7-1.8-2.2 4.9-3.2-1.7 1.1-3.2 2.1-4.9 3.2zm-43 2.6c1.4 1.2-.6 3.5-4.1 4.7 1.5-1.7 2.7-3.2 4.1-4.7zm108 15c-2 1.2-3.6 2.1-5.4 3.2-.5-.6 2.9-1.4-.5-1.5 1.5-1 2.8-2 5.9-1.7zm7.7-88.6c-1 .7-1.9 1.5-3.1 2.1-1.1.6-2.6 1-4.5 1.6 2.6-1.5 4.7-2.8 6.9-4 .2.1.4.2.7.3zM40.2 206.9c-.5 0-1.1.1-1.7.2.7-1.2 4.2-2.3 6.7-2-1.7.7-3.2 1.3-4.8 2 0-.1-.1-.2-.2-.2zm170.1-102.1c-.3-1.9 1.5-3.2 4.5-3.2-1.5 1-3 2.1-4.5 3.2zm162.5 47.8c-1.2-.2-2.4-.4-4-.7.9-.3 1.4-.4 1.8-.6.6-.2 1.2-.5 1.8-.8l.6 1.5c.2.1 0 .3-.2.6zm-101.2 5.7c1.1.2 2.3.2 3.2.5.4.1.4.7.5 1.1-.7 0-1.5.2-1.9 0-.8-.3-1.5-.9-2.2-1.3.2-.1.3-.2.4-.3zm12.6-40.4c.6-.2 1.2-.7 1.6-.7 1.6.1 2 .9 2.1 2-1.2-.4-2.2-.8-3.7-1.3zm-114.9 7.2c.9-1 1.8-2 2.6-2.9 1.6.8.8 1.7-2.6 2.9zm123.3 5c.5.7 1.1 1.3 1.8 2.2-2.6-.2-2.5-1.2-2.4-2 .3-.1.5-.1.6-.2zM68.9 197.7c-1.6 1.9-1.6 1.9-3.6 1.6 1.4-.6 2.5-1.1 3.6-1.6zm108.2-23.4c-.2-.1-.5-.2-.6-.3-.4-.4-.7-.8-1-1.2.3 0 .8-.2.9-.2.6.4 1 .9 1.6 1.4-.4.1-.7.1-.9.3zm8.3-1.7c-1.4.2-2.4.4-3.5.6-.1-.1-.1-.2-.2-.2.7-.4 1.3-.8 2.1-1.2.4.1.9.3 1.6.8zM53.7 205c-.9.3-1.7.6-2.6.9-.1 0-.3-.1-.4-.2.5-.4.8-.9 1.4-1.3.2-.1 1 .1 1.6.2v.4zm272.6-60.5c-.4.9-.7 1.7-1.1 2.7-1-.8-.5-1.9 1.1-2.7zM44.7 203.7c1-.3 2-.7 3-1-.2 1.2-1.2 1.5-2.7 1.4-.1-.1-.2-.3-.3-.4zm297-71.2c.7-.8 1.3-1.5 1.9-2.2 1 .8.5 1.6-1.9 2.2z"
        className="st0"
      />
      <path d="m239.5 96.6 20 11.6 20.3-11.7-20.3-11.6z" className="st1" />
      <linearGradient
        id="SVGID_1_"
        x1={243.104}
        x2={259.452}
        y1={-115.782}
        y2={-115.782}
        gradientTransform="translate(0 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m243.3 97-.2-19 16.4 9.4v19.1z"
        style={{
          fill: 'url(#SVGID_1_)',
        }}
      />
      <linearGradient
        id="SVGID_2_"
        x1={259.471}
        x2={275.925}
        y1={-115.823}
        y2={-115.823}
        gradientTransform="translate(0 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m259.5 106.5 16.4-9.6v-19l-16.4 9.5z"
        style={{
          fill: 'url(#SVGID_2_)',
        }}
      />
      <linearGradient
        id="SVGID_3_"
        x1={243.146}
        x2={275.925}
        y1={-130.113}
        y2={-130.113}
        gradientTransform="translate(0 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m243.1 77.9 16.4 9.5 16.4-9.5-16.5-9.5z"
        style={{
          fill: 'url(#SVGID_3_)',
        }}
      />
      <path
        d="m250.3 82.1 2.7 1.5 16.3-9.5-2.4-1.5zM250.3 82.1V84l2.6 1.4.1-1.8zM253.5 86.6v3.7l4.9 2.9v-3.8z"
        className="st5"
      />
      <path
        d="M255.9 89v-.3l2.1 1.2v.3zM254 88.6v-.4l4 2.3v.4zM254 89.1v-.3l4 2.3v.3zM254 89.7v-.4l4 2.3v.4z"
        className="st6"
      />
      <path d="m264.8 107.7 10.2 5.9 10.4-6-10.4-5.9z" className="st1" />
      <linearGradient
        id="SVGID_4_"
        x1={266.64}
        x2={275.001}
        y1={-102.595}
        y2={-102.595}
        gradientTransform="translate(0 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m266.7 107.8-.1-9.7 8.4 4.8v9.8z"
        style={{
          fill: 'url(#SVGID_4_)',
        }}
      />
      <linearGradient
        id="SVGID_5_"
        x1={274.995}
        x2={283.397}
        y1={-102.637}
        y2={-102.637}
        gradientTransform="translate(0 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m275 112.7 8.4-4.9v-9.7l-8.4 4.8z"
        style={{
          fill: 'url(#SVGID_5_)',
        }}
      />
      <linearGradient
        id="SVGID_6_"
        x1={266.649}
        x2={283.394}
        y1={-109.916}
        y2={-109.916}
        gradientTransform="translate(0 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m266.6 98.1 8.4 4.8 8.4-4.8-8.4-4.9z"
        style={{
          fill: 'url(#SVGID_6_)',
        }}
      />
      <path d="m270.4 100.2 1.2.8 8.4-4.9-1.2-.7z" className="st5" />
      <path
        d="M270.4 100.2v1l1.2.7v-.9zM272 102.5v1.9l2.5 1.5V104z"
        className="st5"
      />
      <path
        d="M273.1 103.8v-.2l1.1.6v.2zM272.2 103.6v-.3l2 1.2v.2zM272.2 103.8v-.2l2 1.2v.2zM272.2 104.1v-.2l2 1.2v.2z"
        className="st6"
      />
      <path d="m66 231.8-20.1 11.6-20.2-11.6L46 220.1z" className="st1" />
      <linearGradient
        id="SVGID_7_"
        x1={489.352}
        x2={505.7}
        y1={19.433}
        y2={19.433}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m62.2 232.2.2-19-16.4 9.4v19.1z"
        style={{
          fill: 'url(#SVGID_7_)',
        }}
      />
      <linearGradient
        id="SVGID_8_"
        x1={505.7}
        x2={522.155}
        y1={19.371}
        y2={19.371}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m46 241.7-16.5-9.6v-19l16.5 9.5z"
        style={{
          fill: 'url(#SVGID_8_)',
        }}
      />
      <linearGradient
        id="SVGID_9_"
        x1={489.394}
        x2={522.173}
        y1={5.082}
        y2={5.082}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="M62.3 213.2 46 222.6l-16.5-9.5 16.6-9.5z"
        style={{
          fill: 'url(#SVGID_9_)',
        }}
      />
      <path d="m55.1 217.3-2.6 1.5-16.3-9.5 2.3-1.5z" className="st5" />
      <path
        d="M55.1 217.3v1.9l-2.5 1.4-.1-1.8zM51.9 221.8v3.7l-4.8 2.8v-3.7z"
        className="st5"
      />
      <path
        d="M49.6 224.2v-.3l-2.1 1.2v.3zM51.5 223.8v-.4l-4 2.3v.4zM51.5 224.3v-.3l-4 2.3v.3zM51.5 224.9v-.3l-4 2.3v.3z"
        className="st6"
      />
      <path d="m40.7 242.9-10.2 5.9-10.4-6 10.4-5.9z" className="st1" />
      <linearGradient
        id="SVGID_10_"
        x1={512.885}
        x2={521.246}
        y1={32.62}
        y2={32.62}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m38.7 243 .1-9.7-8.3 4.8v9.8z"
        style={{
          fill: 'url(#SVGID_10_)',
        }}
      />
      <linearGradient
        id="SVGID_11_"
        x1={521.24}
        x2={529.643}
        y1={32.599}
        y2={32.599}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m30.5 247.9-8.4-4.9v-9.7l8.4 4.8z"
        style={{
          fill: 'url(#SVGID_11_)',
        }}
      />
      <linearGradient
        id="SVGID_12_"
        x1={512.897}
        x2={529.643}
        y1={25.278}
        y2={25.278}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m38.8 233.3-8.3 4.8-8.4-4.8 8.4-4.9z"
        style={{
          fill: 'url(#SVGID_12_)',
        }}
      />
      <path d="m35.1 235.4-1.3.8-8.4-4.9 1.3-.7z" className="st5" />
      <path
        d="M35.1 235.4v1l-1.2.7-.1-.9zM33.5 237.7v1.9l-2.5 1.5v-1.9z"
        className="st5"
      />
      <path
        d="M32.3 239v-.2l-1.1.6v.2zM33.2 238.7v-.1l-2 1.1v.2zM33.2 239v-.1l-2 1.1v.2zM33.2 239.3v-.2l-2 1.2v.2z"
        className="st6"
      />
      <path d="m284.7 191.2-20.1 11.5-20.2-11.6 20.3-11.7z" className="st1" />
      <linearGradient
        id="SVGID_13_"
        x1={270.67}
        x2={287.018}
        y1={-21.271}
        y2={-21.271}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m280.9 191.5.1-19-16.3 9.4V201z"
        style={{
          fill: 'url(#SVGID_13_)',
        }}
      />
      <linearGradient
        id="SVGID_14_"
        x1={287.018}
        x2={303.473}
        y1={-21.312}
        y2={-21.312}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m264.7 201-16.5-9.6v-19l16.5 9.5z"
        style={{
          fill: 'url(#SVGID_14_)',
        }}
      />
      <linearGradient
        id="SVGID_15_"
        x1={270.712}
        x2={303.491}
        y1={-35.601}
        y2={-35.601}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m281 172.4-16.3 9.5-16.5-9.5 16.6-9.5z"
        style={{
          fill: 'url(#SVGID_15_)',
        }}
      />
      <path d="m273.8 176.6-2.6 1.5-16.4-9.5 2.4-1.5z" className="st5" />
      <path
        d="M273.8 176.6v2l-2.5 1.3-.1-1.8zM270.6 181.1v3.7l-4.9 2.9v-3.8z"
        className="st5"
      />
      <path
        d="M268.3 183.5v-.3l-2.1 1.2v.3zM270.1 183.1v-.4l-3.9 2.3v.4zM270.1 183.6v-.3l-3.9 2.3v.3zM270.1 184.2v-.4l-3.9 2.3v.4z"
        className="st6"
      />
      <path d="m259.4 202.2-10.3 5.9-10.3-6 10.4-5.9z" className="st1" />
      <linearGradient
        id="SVGID_16_"
        x1={294.194}
        x2={302.555}
        y1={-8.084}
        y2={-8.084}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m257.4 202.3.1-9.6-8.3 4.7v9.8z"
        style={{
          fill: 'url(#SVGID_16_)',
        }}
      />
      <linearGradient
        id="SVGID_17_"
        x1={302.549}
        x2={310.952}
        y1={-8.126}
        y2={-8.126}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m249.2 207.2-8.4-4.9v-9.7l8.4 4.8z"
        style={{
          fill: 'url(#SVGID_17_)',
        }}
      />
      <linearGradient
        id="SVGID_18_"
        x1={294.215}
        x2={310.961}
        y1={-15.405}
        y2={-15.405}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m257.5 192.6-8.3 4.8-8.4-4.8 8.4-4.9z"
        style={{
          fill: 'url(#SVGID_18_)',
        }}
      />
      <path d="m253.8 194.7-1.3.8-8.4-4.8 1.3-.8z" className="st5" />
      <path
        d="M253.8 194.7v1l-1.3.7v-.9zM252.2 197v1.9l-2.5 1.5v-1.9z"
        className="st5"
      />
      <path
        d="M251 198.3v-.2l-1.1.6v.2zM252 198.1v-.2l-2.1 1.2v.1zM252 198.3v-.2l-2.1 1.2v.2zM252 198.6v-.2l-2.1 1.2v.2z"
        className="st6"
      />
      <path d="m218.4 259.1-20 11.6-20.2-11.7 20.3-11.6z" className="st1" />
      <linearGradient
        id="SVGID_19_"
        x1={336.895}
        x2={353.243}
        y1={46.701}
        y2={46.701}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m214.7 259.5.1-19-16.3 9.3v19.1z"
        style={{
          fill: 'url(#SVGID_19_)',
        }}
      />
      <linearGradient
        id="SVGID_20_"
        x1={353.243}
        x2={369.698}
        y1={46.639}
        y2={46.639}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m198.5 268.9-16.5-9.5v-19.1l16.5 9.5z"
        style={{
          fill: 'url(#SVGID_20_)',
        }}
      />
      <linearGradient
        id="SVGID_21_"
        x1={336.936}
        x2={369.716}
        y1={32.329}
        y2={32.329}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m214.8 240.4-16.3 9.4-16.5-9.5 16.5-9.5z"
        style={{
          fill: 'url(#SVGID_21_)',
        }}
      />
      <path d="m207.6 244.5-2.6 1.6-16.4-9.6 2.4-1.4z" className="st5" />
      <path
        d="M207.6 244.5v2l-2.5 1.4-.1-1.8zM204.4 249v3.8l-4.9 2.8v-3.7z"
        className="st5"
      />
      <path
        d="M202 251.5v-.4l-2.1 1.3v.3zM203.9 251v-.3l-4 2.3v.3zM203.9 251.6v-.4l-4 2.3v.4zM203.9 252.1v-.3l-4 2.3v.3z"
        className="st6"
      />
      <path d="m193.1 270.1-10.2 5.9-10.3-5.9 10.4-6z" className="st1" />
      <linearGradient
        id="SVGID_22_"
        x1={360.422}
        x2={368.777}
        y1={59.867}
        y2={59.867}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m191.2 270.3.1-9.7-8.3 4.8v9.7z"
        style={{
          fill: 'url(#SVGID_22_)',
        }}
      />
      <linearGradient
        id="SVGID_23_"
        x1={368.777}
        x2={377.185}
        y1={59.846}
        y2={59.846}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m183 275.1-8.5-4.8v-9.8l8.5 4.9z"
        style={{
          fill: 'url(#SVGID_23_)',
        }}
      />
      <linearGradient
        id="SVGID_24_"
        x1={360.439}
        x2={377.185}
        y1={52.525}
        y2={52.525}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m191.3 260.6-8.3 4.8-8.5-4.9 8.5-4.8z"
        style={{
          fill: 'url(#SVGID_24_)',
        }}
      />
      <path d="m187.6 262.7-1.3.8-8.4-4.9 1.2-.8z" className="st5" />
      <path
        d="M187.6 262.7v1l-1.3.7v-.9zM185.9 265v1.9l-2.4 1.4v-1.9z"
        className="st5"
      />
      <path
        d="M184.8 266.2v-.2l-1.1.7v.1zM185.7 266v-.2l-2 1.2v.2zM185.7 266.3v-.2l-2 1.2v.2zM185.7 266.6v-.2l-2 1.2v.1z"
        className="st6"
      />
      <path d="m182.9 148.4-20 11.5-20.3-11.6 20.3-11.7z" className="st1" />
      <linearGradient
        id="SVGID_25_"
        x1={372.42}
        x2={388.768}
        y1={-64.034}
        y2={-64.034}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m179.1 148.7.2-19-16.4 9.4v19.1z"
        style={{
          fill: 'url(#SVGID_25_)',
        }}
      />
      <linearGradient
        id="SVGID_26_"
        x1={388.768}
        x2={405.222}
        y1={-64.075}
        y2={-64.075}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m162.9 158.2-16.4-9.6v-19l16.4 9.5z"
        style={{
          fill: 'url(#SVGID_26_)',
        }}
      />
      <linearGradient
        id="SVGID_27_"
        x1={372.461}
        x2={405.241}
        y1={-78.385}
        y2={-78.385}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m179.3 129.7-16.4 9.4-16.4-9.5 16.5-9.4z"
        style={{
          fill: 'url(#SVGID_27_)',
        }}
      />
      <path d="m172.1 133.8-2.6 1.5-16.4-9.4 2.4-1.5z" className="st5" />
      <path
        d="M172.1 133.8v2l-2.6 1.4v-1.9zM168.9 138.3v3.7l-4.9 2.9v-3.8z"
        className="st5"
      />
      <path
        d="M166.5 140.7v-.3l-2.1 1.2v.3zM168.4 140.3v-.3l-4 2.2v.4zM168.4 140.9v-.4l-4 2.3v.4zM168.4 141.4v-.3l-4 2.3v.3z"
        className="st6"
      />
      <path d="m157.6 159.4-10.2 5.9-10.3-6 10.3-5.9z" className="st1" />
      <linearGradient
        id="SVGID_28_"
        x1={395.951}
        x2={404.312}
        y1={-50.868}
        y2={-50.868}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="M155.7 159.6v-9.7l-8.3 4.8v9.7z"
        style={{
          fill: 'url(#SVGID_28_)',
        }}
      />
      <linearGradient
        id="SVGID_29_"
        x1={404.306}
        x2={412.709}
        y1={-50.889}
        y2={-50.889}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m147.4 164.4-8.4-4.9v-9.7l8.4 4.9z"
        style={{
          fill: 'url(#SVGID_29_)',
        }}
      />
      <linearGradient
        id="SVGID_30_"
        x1={395.964}
        x2={412.71}
        y1={-58.168}
        y2={-58.168}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m155.7 149.9-8.3 4.8-8.4-4.9 8.4-4.8z"
        style={{
          fill: 'url(#SVGID_30_)',
        }}
      />
      <path d="m152.1 152-1.3.7-8.4-4.8 1.2-.8z" className="st5" />
      <path
        d="M152.1 152v1l-1.3.7v-1zM150.4 154.3v1.9l-2.5 1.4v-1.9z"
        className="st5"
      />
      <path
        d="M149.3 155.5v-.2l-1.1.6v.2zM150.2 155.3v-.2l-2 1.2v.2zM150.2 155.6v-.2l-2 1.1v.2zM150.2 155.8v-.1l-2 1.1v.2z"
        className="st6"
      />
      <path d="M370.9 140.5 350.8 152l-20.1-11.6 20.2-11.7z" className="st1" />
      <linearGradient
        id="SVGID_31_"
        x1={184.437}
        x2={200.785}
        y1={-71.979}
        y2={-71.979}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m367.1 140.8.2-19-16.4 9.4v19.1z"
        style={{
          fill: 'url(#SVGID_31_)',
        }}
      />
      <linearGradient
        id="SVGID_32_"
        x1={200.785}
        x2={217.24}
        y1={-72.02}
        y2={-72.02}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m350.9 150.3-16.4-9.6v-19l16.4 9.5z"
        style={{
          fill: 'url(#SVGID_32_)',
        }}
      />
      <linearGradient
        id="SVGID_33_"
        x1={184.479}
        x2={217.258}
        y1={-86.309}
        y2={-86.309}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m367.2 121.7-16.3 9.5-16.4-9.5 16.5-9.5z"
        style={{
          fill: 'url(#SVGID_33_)',
        }}
      />
      <path
        d="m360 125.9-2.5 1.5-16.4-9.5 2.4-1.5zM360 125.9v1.9l-2.5 1.4v-1.8zM356.8 130.4v3.7L352 137v-3.8z"
        className="st5"
      />
      <path
        d="M354.5 132.8v-.3l-2.1 1.2v.3zM356.4 132.4v-.4l-4 2.3v.4zM356.4 132.9v-.3l-4 2.3v.3zM356.4 133.5v-.4l-4 2.3v.4z"
        className="st6"
      />
      <path d="m345.6 151.5-10.2 5.9-10.3-6 10.3-5.9z" className="st1" />
      <linearGradient
        id="SVGID_34_"
        x1={207.958}
        x2={216.32}
        y1={-58.772}
        y2={-58.772}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m343.6 151.6.2-9.7-8.4 4.8v9.8z"
        style={{
          fill: 'url(#SVGID_34_)',
        }}
      />
      <linearGradient
        id="SVGID_35_"
        x1={216.314}
        x2={224.717}
        y1={-58.813}
        y2={-58.813}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m335.4 156.5-8.4-4.9v-9.7l8.4 4.8z"
        style={{
          fill: 'url(#SVGID_35_)',
        }}
      />
      <linearGradient
        id="SVGID_36_"
        x1={207.982}
        x2={224.727}
        y1={-66.114}
        y2={-66.114}
        gradientTransform="matrix(-1 0 0 1 551.712 208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#f97373',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fd8787',
          }}
        />
      </linearGradient>
      <path
        d="m343.7 141.9-8.3 4.8-8.4-4.8 8.5-4.9z"
        style={{
          fill: 'url(#SVGID_36_)',
        }}
      />
      <path d="m340.1 144-1.4.8-8.3-4.8 1.2-.8z" className="st5" />
      <path
        d="M340.1 144v1l-1.3.7-.1-.9zM338.4 146.3v1.9l-2.4 1.5v-1.9z"
        className="st5"
      />
      <path
        d="M337.2 147.6v-.2l-1 .6v.2zM338.2 147.4v-.3l-2 1.3v.1zM338.2 147.6v-.2l-2 1.2v.2zM338.2 147.9v-.2l-2 1.2v.2z"
        className="st6"
      />
    </svg>
  );
}
